export default [{
    "title": "常用函数",
    "children": [[{
        "name": "area_s",
        "type": "function",
        "groups": ["System"],
        "description": "Returns the area of the current feature. The area calculated by this function respects both the current project's ellipsoid setting and area unit settings. For example, if an ellipsoid has been set for the project then the calculated area will be ellipsoidal, and if no ellipsoid is set then the calculated area will be planimetric.",
        "examples": [{"expression": "area_s", "returns": "42"}],
        "tags": ["planimetric", "current", "area", "surface", "project", "settings", "ellipsoid", "setting", "calculated"]
    }, {
        "name": "area_s",
        "type": "function",
        "groups": ["System"],
        "description": "返回当前要素的面积。此函数计算的面积符合当前项目的椭圆体设置和面积单位设置。例如,如果已为项目设置了椭圆体,则计算的面积将是椭圆体的,如果没有设置椭圆体,则计算的面积将是平面的。",
        "examples": [{"expression": "area_s", "returns": "42"}],
        "tags": ["planimetric", "current", "area", "surface", "project", "settings", "ellipsoid", "setting", "calculated"]
    }], [{
        "name": "center_s",
        "type": "function",
        "groups": ["System"],
        "description": "Return the geometric center point (centroid) coordinates (latitude and longitude) of the polygon",
        "examples": [{"expression": "center_s", "returns": "113.431,42.234"}],
        "tags": ["first", "point", "coordinate", "center", "polygon"]
    }, {
        "name": "center_s",
        "type": "function",
        "groups": ["System"],
        "description": "返回当前面元素的几何中心点(重心)坐标（经纬度）。",
        "examples": [{"expression": "center_s", "returns": "113.431,42.234"}],
        "tags": ["first", "polygon", "coordinate", "center", "point"]
    }], [{
        "name": "centroid_s",
        "type": "function",
        "groups": ["System"],
        "description": "Return the centroid coordinates (latitude and longitude) of the polygon. The centroid must be inside of the polygon.",
        "examples": [{"expression": "centroid_s", "returns": "113.431,42.234"}],
        "tags": ["first", "point", "coordinate", "current", "polygon"]
    }, {
        "name": "centroid_s",
        "type": "function",
        "groups": ["System"],
        "description": "返回当前面元素的质心点坐标（经纬度）。质心点一定在多边形内部。",
        "examples": [{"expression": "centroid_s", "returns": "113.431,42.234"}],
        "tags": ["first", "polygon", "coordinate", "center", "point"]
    }], [{
        "name": "cgcs2000_cm_x",
        "type": "function",
        "groups": ["System"],
        "description": "Returns the CGCS2000 x with central meridian coordinate of the current point feature. If the feature is a multipoint feature, then the x-coordinate of the first point will be returned. <b>WARNING: This function is deprecated. It is recommended to use the replacement x() function with @geometry variable instead.<\/b>",
        "examples": [{"expression": "cgcs2000_cm_x", "returns": "42"}],
        "tags": ["first", "point", "coordinate", "current", "multipoint"]
    }, {
        "name": "cgcs2000_cm_x",
        "type": "function",
        "groups": ["System"],
        "description": "返回当前点要素的 CGCS2000的x (中央子午线)。如果要素是多点要素,则将返回第一个点的 x 坐标。",
        "examples": [{"expression": "cgcs2000_cm_x", "returns": "42"}],
        "tags": ["first", "point", "coordinate", "current", "multipoint"]
    }], [{
        "name": "cgcs2000_cm_y",
        "type": "function",
        "groups": ["System"],
        "description": "Returns the CGCS2000 y with central meridian coordinate of the current point feature. If the feature is a multipoint feature, then the y-coordinate of the first point will be returned.",
        "examples": [{"expression": "cgcs2000_cm_y", "returns": "42"}],
        "tags": ["first", "point", "coordinate", "current", "multipoint"]
    }, {
        "name": "cgcs2000_cm_y",
        "type": "function",
        "groups": ["System"],
        "description": "返回当前点要素的 CGCS2000的y坐标(中央子午线)。如果要素是多点要素,则将返回第一个点的 y 坐标。",
        "examples": [{"expression": "cgcs2000_cm_y", "returns": "42"}],
        "tags": ["first", "point", "coordinate", "current", "multipoint"]
    }], [{
        "name": "cgcs2000_x",
        "type": "function",
        "groups": ["System"],
        "description": "Returns the CGCS2000 x coordinate of the current point feature. If the feature is a multipoint feature, then the x-coordinate of the first point will be returned. ",
        "examples": [{"expression": "cgcs2000_x", "returns": "42"}],
        "tags": ["first", "point", "coordinate", "current", "multipoint"]
    }, {
        "name": "cgcs2000_x",
        "type": "function",
        "groups": ["System"],
        "description": "返回当前点要素的 CGCS2000的x坐标。如果要素是多点要素,则将返回第一个点的 x 坐标。",
        "examples": [{"expression": "cgcs2000_x", "returns": "42"}],
        "tags": ["first", "point", "coordinate", "current", "multipoint"]
    }], [{
        "name": "cgcs2000_y",
        "type": "function",
        "groups": ["System"],
        "description": "Returns the CGCS2000 y coordinate of the current point feature. If the feature is a multipoint feature, then the y-coordinate of the first point will be returned.",
        "examples": [{"expression": "cgcs2000_y", "returns": "42"}],
        "tags": ["first", "point", "coordinate", "current", "multipoint"]
    }, {
        "name": "cgcs2000_y",
        "type": "function",
        "groups": ["System"],
        "description": "返回当前点要素的 CGCS2000的y坐标。如果要素是多点要素,则将返回第一个点的 y 坐标。",
        "examples": [{"expression": "cgcs2000_y", "returns": "42"}],
        "tags": ["first", "point", "coordinate", "current", "multipoint"]
    }], [{
        "name": "geometry_s",
        "type": "function",
        "groups": ["System"],
        "description": "Returns the geometry of the current feature. Can be used for processing with other functions.",
        "examples": [{"expression": "geometry_s()", "returns": "POINTS{(119,38),（119.45,38.343）,.......}"}],
        "tags": ["current", "processing", "functions"]
    }, {
        "name": "geometry_s",
        "type": "function",
        "groups": ["System"],
        "description": "返回当前对象的坐标数组。可用于与其他函数一起处理。",
        "examples": [{"expression": "geometry_s()", "returns": "POINTS{(119,38),（119.45,38.343）,.......}"}],
        "tags": ["current", "processing", "functions"]
    }], [{
        "name": "length_s",
        "type": "function",
        "groups": ["System"],
        "description": "Returns the length of a linestring. If you need the length of a border of a polygon, use perimeter_s instead. The length calculated by this function respects both the current project's ellipsoid setting and distance unit settings. For example, if an ellipsoid has been set for the project then the calculated length will be ellipsoidal, and if no ellipsoid is set then the calculated length will be planimetric.",
        "examples": [{"expression": "length_s", "returns": "42.4711"}],
        "tags": ["distance", "planimetric", "length", "perimeter", "current", "linestring", "project", "settings", "ellipsoid", "border", "setting", "calculated"]
    }, {
        "name": "length_s",
        "type": "function",
        "groups": ["System"],
        "description": "返回线的长度。如果您需要多边形边框的长度,请改用 perimeter_s。此函数计算的长度同时遵循当前项目的椭圆体设置和距离单位设置。例如,如果已为项目设置了椭圆体,则计算的长度将是椭圆体的,如果没有设置椭圆体,则计算的长度将是平面的。",
        "examples": [{"expression": "length_s", "returns": "42.4711"}],
        "tags": ["distance", "planimetric", "length", "perimeter", "current", "linestring", "project", "settings", "ellipsoid", "border", "setting", "calculated"]
    }], [{
        "name": "location_ad",
        "type": "function",
        "groups": ["GeometryGroup"],
        "description": "Returns the Administrative division(Location) value of the current point . ",
        "examples": [{
            "expression": "location_ad(Point(120.53027,40.7840))",
            "returns": "中国 辽宁省 葫芦岛市 兴城市 华山街道"
        }],
        "tags": ["first", "point", "current", "multipoint", "altitude", "3D"]
    }, {
        "name": "location_ad",
        "type": "function",
        "groups": ["GeometryGroup"],
        "description": "返回当前点的行政区划（位置）值。",
        "examples": [{
            "expression": "location_ad(Point(120.53027,40.7840))",
            "returns": "中国 辽宁省 葫芦岛市 兴城市 华山街道"
        }],
        "tags": ["first", "point", "current", "multipoint", "altitude", "3D"]
    }], [{
        "name": "perimeter_s",
        "type": "function",
        "groups": ["System"],
        "description": "Returns the perimeter length of the current feature. The perimeter calculated by this function respects both the current project's ellipsoid setting and distance unit settings. For example, if an ellipsoid has been set for the project then the calculated perimeter will be ellipsoidal, and if no ellipsoid is set then the calculated perimeter will be planimetric.",
        "examples": [{"expression": "perimeter_s", "returns": "42"}],
        "tags": ["distance", "planimetric", "length", "perimeter", "current", "polygon", "project", "settings", "ellipsoid", "setting", "calculated"]
    }, {
        "name": "perimeter_s",
        "type": "function",
        "groups": ["System"],
        "description": "返回当前要素的周长。此函数计算出的周长符合当前项目的椭圆体设置和距离单位设置。例如,如果已为项目设置了椭圆体,则计算出的周长将是椭圆体,如果未设置椭圆体,则计算出的周长将是平面的。",
        "examples": [{"expression": "perimeter_s", "returns": "42"}],
        "tags": ["distance", "planimetric", "length", "perimeter", "current", "polygon", "project", "settings", "ellipsoid", "setting", "calculated"]
    }], [{
        "name": "vertex_Lat",
        "type": "function",
        "groups": ["System"],
        "description": "Returns the latitude coordinate of the current mesh vertex.",
        "examples": [{"expression": "vertex_Lat", "returns": "42.12"}],
        "tags": ["coordinate", "mesh", "vertex", "current"]
    }, {
        "name": "vertex_Lat",
        "type": "function",
        "groups": ["System"],
        "description": "返回当前网格点的纬度坐标。",
        "examples": [{"expression": "vertex_Lat", "returns": "42.12"}],
        "tags": ["coordinate", "mesh", "vertex", "current"]
    }], [{
        "name": "vertex_Lon",
        "type": "function",
        "groups": ["System"],
        "description": "Returns the longitude coordinate of the current mesh vertex.",
        "examples": [{"expression": "vertex_Lon", "returns": "12.24"}],
        "tags": ["coordinate", "mesh", "vertex", "current"]
    }, {
        "name": "vertex_Lon",
        "type": "function",
        "groups": ["System"],
        "description": "返回当前网格点的经度坐标。",
        "examples": [{"expression": "vertex_Lon", "returns": "12.24"}],
        "tags": ["coordinate", "mesh", "vertex", "current"]
    }], [{
        "name": "vertex_ele",
        "type": "function",
        "groups": ["System"],
        "description": "Returns the elevation (Z) value of the current mesh vertex.",
        "examples": [{"expression": "vertex_ele", "returns": "42"}],
        "tags": ["mesh", "vertex", "current"]
    }, {
        "name": "vertex_ele",
        "type": "function",
        "groups": ["System"],
        "description": "返回当前网格点的高程（Z）值。",
        "examples": [{"expression": "vertex_ele", "returns": "42"}],
        "tags": ["mesh", "vertex", "current"]
    }], [{
        "name": "zonecode_s",
        "type": "function",
        "groups": ["System"],
        "description": "Returns the zone code of the current feature.",
        "arguments": [{
            "arg": "method",
            "description": "The zone method among country['CNTY'], provice['Prov'], city['City'],district[Dist],township['Twp']"
        }],
        "examples": [{"expression": "zonecode_s('Prov')", "returns": "510000000000"}],
        "tags": ["zone", "code", "name", "city"]
    }, {
        "name": "zonecode_s",
        "type": "function",
        "groups": ["System"],
        "description": "返回当前要素的行政区域代码省、市、区县、乡镇。",
        "arguments": [{
            "arg": "method",
            "description": "参数'method'的取值包括 国家['CNTY'], 省['Prov'], 市['City'],区县['Dist'],乡镇['Twp']"
        }],
        "examples": [{"expression": "zonecode_s('Prov')", "returns": "510000000000"}],
        "tags": ["zone", "code", "name", "city"]
    }]]
}, {
    "title": "运算符",
    "children": [[{
        "name": "%",
        "type": "operator",
        "groups": ["Operators"],
        "description": "两个数相除求余数。",
        "examples": [{"expression": "5 % 4", "returns": "1"}, {
            "expression": "TRUE AND FALSE",
            "returns": "FALSE"
        }, {"expression": "5 % NULL ", "returns": "NULL"}],
        "tags": ["condition"]
    }, {
        "name": "%",
        "type": "operator",
        "groups": ["Operators"],
        "description": "两个数相除求余数。",
        "examples": [{"expression": "5 % 4", "returns": "1"}, {
            "expression": "TRUE AND FALSE",
            "returns": "FALSE"
        }, {"expression": "5 % NULL ", "returns": "NULL"}],
        "tags": ["condition"]
    }], [{
        "name": "+",
        "type": "operator",
        "groups": ["Operators"],
        "description": "两个值相加求和。若其中一个值为NULL（空），则结果也为NULL。",
        "examples": [{"expression": "5 + 4", "returns": "9"}, {"expression": "5 + NULL ", "returns": "NULL"}],
        "tags": ["condition"]
    }, {
        "name": "+",
        "type": "operator",
        "groups": ["Operators"],
        "description": "两个值相加求和。若其中一个值为NULL（空），则结果也为NULL。",
        "examples": [{"expression": "5 + 4", "returns": "9"}, {"expression": "5 + NULL ", "returns": "NULL"}],
        "tags": ["condition"]
    }], [{
        "name": "=",
        "type": "operator",
        "groups": ["Operators"],
        "description": "比较两个值是否相等，若相等则返回1。",
        "examples": [{"expression": "5 = 4", "returns": "0"}, {
            "expression": "5 = 5",
            "returns": "1"
        }, {"expression": "4 = NULL ", "returns": "NULL"}],
        "tags": ["condition"]
    }, {
        "name": "=",
        "type": "operator",
        "groups": ["Operators"],
        "description": "比较两个值是否相等，若相等则返回1。",
        "examples": [{"expression": "5 = 4", "returns": "0"}, {
            "expression": "5 = 5",
            "returns": "1"
        }, {"expression": "4 = NULL ", "returns": "NULL"}],
        "tags": ["condition"]
    }], [{
        "name": "~",
        "type": "operator",
        "groups": ["Operators"],
        "description": "在字符串上应用正则表达式。",
        "examples": [{"expression": "'hello' ~ 'll'", "returns": "1"}, {
            "expression": "'hello' ~ '^ll'",
            "returns": "0"
        }, {"expression": "'hello' ~ 'llo$'  ", "returns": "1"}],
        "tags": ["condition"]
    }, {
        "name": "~",
        "type": "operator",
        "groups": ["Operators"],
        "description": "在字符串上应用正则表达式。",
        "examples": [{"expression": "'hello' ~ 'll'", "returns": "1"}, {
            "expression": "'hello' ~ '^ll'",
            "returns": "0"
        }, {"expression": "'hello' ~ 'llo$'  ", "returns": "1"}],
        "tags": ["condition"]
    }], [{
        "name": "*",
        "type": "operator",
        "groups": ["Operators"],
        "description": "两个数相乘求积。",
        "examples": [{"expression": "5 * 4", "returns": "20"}, {
            "expression": "TRUE AND FALSE",
            "returns": "FALSE"
        }, {"expression": "5 * NULL ", "returns": "NULL"}],
        "tags": ["condition"]
    }, {
        "name": "*",
        "type": "operator",
        "groups": ["Operators"],
        "description": "两个数相乘求积。",
        "examples": [{"expression": "5 * 4", "returns": "20"}, {
            "expression": "TRUE AND FALSE",
            "returns": "FALSE"
        }, {"expression": "5 * NULL ", "returns": "NULL"}],
        "tags": ["condition"]
    }], [{
        "name": "^",
        "type": "operator",
        "groups": ["Operators"],
        "description": "求甲值的乙次幂。",
        "examples": [{"expression": "5 ^ 4 ", "returns": "625"}, {"expression": "5 ^NULL ", "returns": "NULL"}],
        "tags": ["condition"]
    }, {
        "name": "^",
        "type": "operator",
        "groups": ["Operators"],
        "description": "求甲值的乙次幂。",
        "examples": [{"expression": "5 ^ 4 ", "returns": "625"}, {"expression": "5 ^NULL ", "returns": "NULL"}],
        "tags": ["condition"]
    }], [{
        "name": "<",
        "type": "operator",
        "groups": ["Operators"],
        "description": "比较两个值的大小。若左边的值小于右边的值，则返回1。",
        "examples": [{"expression": "5 < 4", "returns": "0"}, {
            "expression": "5 < 5",
            "returns": "0"
        }, {"expression": "4< 5 ", "returns": "1"}],
        "tags": ["condition"]
    }, {
        "name": "<",
        "type": "operator",
        "groups": ["Operators"],
        "description": "比较两个值的大小。若左边的值小于右边的值，则返回1。",
        "examples": [{"expression": "5 < 4", "returns": "0"}, {
            "expression": "5 < 5",
            "returns": "0"
        }, {"expression": "4< 5 ", "returns": "1"}],
        "tags": ["condition"]
    }], [{
        "name": ">",
        "type": "operator",
        "groups": ["Operators"],
        "description": "比较两个值的大小。若左边的值大于右边的值，则返回1。",
        "examples": [{"expression": "5  > 4", "returns": "1"}, {
            "expression": "5 > 5",
            "returns": "0"
        }, {"expression": "4 > 5 ", "returns": "0"}],
        "tags": ["condition"]
    }, {
        "name": ">",
        "type": "operator",
        "groups": ["Operators"],
        "description": "比较两个值的大小。若左边的值大于右边的值，则返回1。",
        "examples": [{"expression": "5  > 4", "returns": "1"}, {
            "expression": "5 > 5",
            "returns": "0"
        }, {"expression": "4 > 5 ", "returns": "0"}],
        "tags": ["condition"]
    }], [{
        "name": "\/",
        "type": "operator",
        "groups": ["Operators"],
        "description": "两个数相除求商。",
        "examples": [{"expression": "5 \/ 4", "returns": "1.25"}, {
            "expression": "TRUE AND FALSE",
            "returns": "FALSE"
        }, {"expression": "5 \/ NULL ", "returns": "NULL"}],
        "tags": ["condition"]
    }, {
        "name": "\/",
        "type": "operator",
        "groups": ["Operators"],
        "description": "两个数相除求商。",
        "examples": [{"expression": "5 \/ 4", "returns": "1.25"}, {
            "expression": "TRUE AND FALSE",
            "returns": "FALSE"
        }, {"expression": "5 \/ NULL ", "returns": "NULL"}],
        "tags": ["condition"]
    }], [{
        "name": "-",
        "type": "operator",
        "groups": ["Operators"],
        "description": "两个值相减求差。若其中一个值为NULL（空），则结果也为NULL。",
        "examples": [{"expression": "5 - 4", "returns": "1"}, {
            "expression": "TRUE AND FALSE",
            "returns": "FALSE"
        }, {"expression": "5 - NULL ", "returns": "NULL"}],
        "tags": ["condition"]
    }, {
        "name": "-",
        "type": "operator",
        "groups": ["Operators"],
        "description": "两个值相减求差。若其中一个值为NULL（空），则结果也为NULL。",
        "examples": [{"expression": "5 - 4", "returns": "1"}, {
            "expression": "TRUE AND FALSE",
            "returns": "FALSE"
        }, {"expression": "5 - NULL ", "returns": "NULL"}],
        "tags": ["condition"]
    }], [{
        "name": "IS",
        "type": "operator",
        "groups": ["Operators"],
        "description": "Returns TRUE if a is the same as b.",
        "arguments": [{"arg": "a", "description": "any value"}, {"arg": "b", "description": "any value"}],
        "examples": [{"expression": "'A' IS 'A'", "returns": "TRUE"}, {
            "expression": "'A' IS 'a'",
            "returns": "FALSE"
        }, {"expression": "4 IS 4", "returns": "TRUE"}, {
            "expression": "4 IS 2+2",
            "returns": "TRUE"
        }, {"expression": "4 IS 2", "returns": "FALSE"}, {
            "expression": "@geometry IS NULL",
            "returns": "0, if your geometry is not NULL"
        }],
        "tags": ["compare", "same", "equal", "identical"]
    }, {
        "name": "IS",
        "type": "operator",
        "groups": ["Operators"],
        "description": "如果 a 与 b 相同,则返回 TRUE。",
        "arguments": [{"arg": "a", "description": "任意值"}, {"arg": "b", "description": "任意值"}],
        "examples": [{"expression": "'A' IS 'A'", "returns": "TRUE"}, {
            "expression": "'A' IS 'a'",
            "returns": "FALSE"
        }, {"expression": "'A' IS 'a'", "returns": "FALSE"}, {
            "expression": "4 IS 4",
            "returns": "TRUE"
        }, {"expression": "4 IS 2+2", "returns": "TRUE"}, {
            "expression": "4 IS 2",
            "returns": "FALSE"
        }, {"expression": "@geometry IS NULL", "returns": "0, if your geometry is not NULL"}],
        "tags": ["compare", "same", "equal", "identical"]
    }], [{
        "name": "<>",
        "type": "operator",
        "groups": ["Operators"],
        "description": "比较两个值是否相等，若不相等则返回1。",
        "examples": [{"expression": "5 <> 4", "returns": "1"}, {
            "expression": "5 <> 5",
            "returns": "0"
        }, {"expression": "4<>NULL ", "returns": "NULL"}],
        "tags": ["condition"]
    }, {
        "name": "<>",
        "type": "operator",
        "groups": ["Operators"],
        "description": "比较两个值是否相等，若不相等则返回1。",
        "examples": [{"expression": "5 <> 4", "returns": "1"}, {
            "expression": "5 <> 5",
            "returns": "0"
        }, {"expression": "4<>NULL ", "returns": "NULL"}],
        "tags": ["condition"]
    }], [{
        "name": ">=",
        "type": "operator",
        "groups": ["Operators"],
        "description": "比较两个值的大小。若左边的值大于或等于右边的值，则返回1。",
        "examples": [{"expression": "5  >= 4", "returns": "1"}, {
            "expression": "5 >= 5",
            "returns": "1"
        }, {"expression": "4 >= 5 ", "returns": "0"}],
        "tags": ["condition"]
    }, {
        "name": ">=",
        "type": "operator",
        "groups": ["Operators"],
        "description": "比较两个值的大小。若左边的值大于或等于右边的值，则返回1。",
        "examples": [{"expression": "5  >= 4", "returns": "1"}, {
            "expression": "5 >= 5",
            "returns": "1"
        }, {"expression": "4 >= 5 ", "returns": "0"}],
        "tags": ["condition"]
    }], [{
        "name": "IN",
        "type": "operator",
        "groups": ["Operators"],
        "description": "Returns TRUE if value is found within a list of values.",
        "arguments": [{"arg": "a", "description": "value"}, {"arg": "b", "description": "list of values"}],
        "examples": [{"expression": "'A' IN ('A','B')", "returns": "TRUE"}, {
            "expression": "'A' IN ('C','B')",
            "returns": "FALSE"
        }],
        "tags": ["list", "contained", "found"]
    }, {
        "name": "IN",
        "type": "operator",
        "groups": ["Operators"],
        "description": "如果在值列表中找到值,则返回 TRUE。",
        "arguments": [{"arg": "a", "description": "value"}, {"arg": "b", "description": "值列表"}],
        "examples": [{"expression": "'A' IN ('A','B')", "returns": "TRUE"}, {
            "expression": "'A' IN ('C','B')",
            "returns": "FALSE"
        }],
        "tags": ["list", "contained", "found"]
    }], [{
        "name": "<=",
        "type": "operator",
        "groups": ["Operators"],
        "description": "比较两个值的大小。若左边的值小于或等于右边的值，则返回1。。",
        "examples": [{"expression": "5 <= 4", "returns": "0"}, {
            "expression": "5 <= 5",
            "returns": "1"
        }, {"expression": "4<= 5 ", "returns": "1"}],
        "tags": ["condition"]
    }, {
        "name": "<=",
        "type": "operator",
        "groups": ["Operators"],
        "description": "比较两个值的大小。若左边的值小于或等于右边的值，则返回1。",
        "examples": [{"expression": "5 <= 4", "returns": "0"}, {
            "expression": "5 <= 5",
            "returns": "1"
        }, {"expression": "4<= 5 ", "returns": "1"}],
        "tags": ["condition"]
    }], [{
        "name": "||",
        "type": "operator",
        "groups": ["Operators"],
        "description": "合并两个值生成一个新的字符串。如果其中一个值是NULL，那么结果也会是NULL，而CONCAT函数则不会，具体参考CONCAT函数文档。",
        "examples": [{
            "expression": "'这里' || '和' || '那里' → '这里和那里'",
            "returns": "这里和那里"
        }, {"expression": "'空空如也' || NULL → NULL", "returns": "NULL"}, {
            "expression": "1 || 2 → '12' ",
            "returns": "12"
        }],
        "tags": ["condition"]
    }, {
        "name": "||",
        "type": "operator",
        "groups": ["Operators"],
        "description": "合并两个值生成一个新的字符串。如果其中一个值是NULL，那么结果也会是NULL，而CONCAT函数则不会，具体参考CONCAT函数文档。",
        "examples": [{
            "expression": "'这里' || '和' || '那里' ",
            "returns": "'这里和那里'"
        }, {"expression": "'空空如也' || NULL", "returns": "NULL"}, {"expression": "1 || 2  ", "returns": "'12'"}],
        "tags": ["condition"]
    }], [{
        "name": "OR",
        "type": "operator",
        "groups": ["Operators"],
        "description": "Returns TRUE when condition a or b is true.",
        "arguments": [{"arg": "a", "description": "condition"}, {"arg": "b", "description": "condition"}],
        "examples": [{"expression": "4 = 2+2 OR 1 = 1", "returns": "TRUE"}, {
            "expression": "4 = 2+2 OR 1 = 2",
            "returns": "TRUE"
        }, {"expression": "4 = 2   OR 1 = 2", "returns": "FALSE"}],
        "tags": ["condition"]
    }, {
        "name": "OR",
        "type": "operator",
        "groups": ["Operators"],
        "description": "当条件 a 或 b 为真时返回 TRUE。",
        "arguments": [{"arg": "a", "description": "condition"}, {"arg": "b", "description": "condition"}],
        "examples": [{"expression": "4 = 2+2 OR 1 = 1", "returns": "TRUE"}, {
            "expression": "4 = 2+2 OR 1 = 2",
            "returns": "TRUE"
        }, {"expression": "4 = 2 OR 1 = 2", "returns": "FALSE"}],
        "tags": ["condition"]
    }], [{
        "name": "NOT",
        "type": "operator",
        "groups": ["Operators"],
        "description": "Negates a condition.",
        "arguments": [{"arg": "a", "description": "condition"}],
        "examples": [{"expression": "NOT 1", "returns": "FALSE"}, {"expression": "NOT 0", "returns": "TRUE"}],
        "tags": ["negates", "condition"]
    }, {
        "name": "NOT",
        "type": "operator",
        "groups": ["Operators"],
        "description": "否定条件。",
        "arguments": [{"arg": "a", "description": "条件"}],
        "examples": [{"expression": "NOT 1", "returns": "FALSE"}, {"expression": "NOT 0", "returns": "TRUE"}],
        "tags": ["negates", "condition"]
    }], [{
        "name": "AND",
        "type": "operator",
        "groups": ["Operators"],
        "description": "Returns TRUE when conditions a and b are true.",
        "arguments": [{"arg": "a", "description": "condition a"}, {"arg": "b", "description": "condition b"}],
        "examples": [{"expression": "TRUE OR TRUE", "returns": "TRUE"}, {
            "expression": "TRUE AND FALSE",
            "returns": "FALSE"
        }, {"expression": "4 = 2+2 AND 1 = 1", "returns": "TRUE"}, {
            "expression": "4 = 2+2 AND 1 = 2",
            "returns": "FALSE"
        }],
        "tags": ["condition"]
    }, {
        "name": "AND",
        "type": "operator",
        "groups": ["Operators"],
        "description": "当条件 a 和 b 为真时返回 TRUE。",
        "arguments": [{"arg": "a", "description": "条件a"}, {"arg": "b", "description": "条件b"}],
        "examples": [{"expression": "TRUE AND TRUE", "returns": "TRUE"}, {
            "expression": "TRUE AND FALSE",
            "returns": "FALSE"
        }, {"expression": "4 = 2+2 AND 1 = 1", "returns": "TRUE"}, {
            "expression": "4 = 2+2 AND 1 = 2",
            "returns": "FALSE"
        }],
        "tags": ["condition"]
    }], [{
        "name": "[ ]",
        "type": "operator",
        "groups": ["Operators"],
        "description": "索引操作符，返回数组或字典中的一个值。",
        "examples": [{"expression": "array(1,2,3)[0] ", "returns": "1"}, {
            "expression": "array(1,2,3)[2] ",
            "returns": "3"
        }, {"expression": "map('a',1,'b',2)['a'] ", "returns": "1"}, {
            "expression": "map('a',1,'b',2)['b'] ",
            "returns": "2"
        }],
        "tags": ["condition"]
    }, {
        "name": "[ ]",
        "type": "operator",
        "groups": ["Operators"],
        "description": "索引操作符，返回数组或字典中的一个值。",
        "examples": [{"expression": "array(1,2,3)[0] ", "returns": "1"}, {
            "expression": "array(1,2,3)[2] ",
            "returns": "3"
        }, {"expression": "map('a',1,'b',2)['a'] ", "returns": "1"}, {
            "expression": "map('a',1,'b',2)['b'] ",
            "returns": "2"
        }],
        "tags": ["condition"]
    }], [{
        "name": "LIKE",
        "type": "operator",
        "groups": ["Operators"],
        "description": "Returns TRUE if the first parameter matches the supplied pattern. Works with numbers also.",
        "arguments": [{"arg": "string\/number", "description": "value"}, {
            "arg": "pattern",
            "description": "pattern to compare value with, you can use '%' as a wildcard, '_' as a single char and '\\\\\\\\' to escape these special characters."
        }],
        "examples": [{"expression": "'A' LIKE 'A'", "returns": "TRUE"}, {
            "expression": "'A' LIKE 'a'",
            "returns": "FALSE"
        }, {"expression": "'A' LIKE 'B'", "returns": "FALSE"}, {
            "expression": "'ABC' LIKE 'B'",
            "returns": "FALSE"
        }, {"expression": "'ABC' LIKE '_B_'", "returns": "TRUE"}, {
            "expression": "'ABCD' LIKE '_B_'",
            "returns": "FALSE"
        }, {"expression": "'ABCD' LIKE '_B%'", "returns": "TRUE"}, {
            "expression": "'ABCD' LIKE '%B%'",
            "returns": "TRUE"
        }, {"expression": "'1%' LIKE '1\\\\\\\\%'", "returns": "TRUE"}, {
            "expression": "'1_' LIKE '1\\\\\\\\%'",
            "returns": "FALSE"
        }],
        "tags": ["compare", "sensitive", "numbers", "first", "end", "start", "begin", "works", "supplied", "parameter", "matches", "pattern"]
    }, {
        "name": "LIKE",
        "type": "operator",
        "groups": ["Operators"],
        "description": "如果第一个参数与提供的模式匹配,则返回 TRUE。也适用于数字。",
        "arguments": [{"arg": "string\/number", "description": "value"}, {
            "arg": "pattern",
            "description": "用于比较值的模式,您可以使用 '%' 作为通配符,'_' 作为单个字符,'\\\\\\\\' 来转义这些特殊字符。"
        }],
        "examples": [{"expression": "'A' LIKE 'A'", "returns": "TRUE"}, {
            "expression": "'A' LIKE 'a'",
            "returns": "FALSE"
        }, {"expression": "'A' LIKE 'B'", "returns": "FALSE"}, {
            "expression": "'ABC' LIKE 'B'",
            "returns": "FALSE"
        }, {"expression": "'ABC' LIKE '_B_'", "returns": "TRUE"}, {
            "expression": "'ABCD' LIKE '_B_'",
            "returns": "FALSE"
        }, {"expression": "'ABCD' LIKE '_B%'", "returns": "TRUE"}, {
            "expression": "'ABCD' LIKE '%B%'",
            "returns": "TRUE"
        }, {"expression": "'1%' LIKE '1\\\\\\\\%'", "returns": "TRUE"}, {
            "expression": "'1_' LIKE '1\\\\\\\\%'",
            "returns": "FALSE"
        }],
        "tags": ["compare", "sensitive", "numbers", "first", "end", "start", "begin", "works", "supplied", "parameter", "matches", "pattern"]
    }], [{
        "name": "ILIKE",
        "type": "operator",
        "groups": ["Operators"],
        "description": "Returns TRUE if the first parameter matches case-insensitive the supplied pattern. LIKE can be used instead of ILIKE to make the match case-sensitive. Works with numbers also.",
        "arguments": [{"arg": "string\/number", "description": "string to search"}, {
            "arg": "pattern",
            "description": "pattern to find, you can use '%' as a wildcard, '_' as a single char and '\\\\\\\\' to escape these special characters."
        }],
        "examples": [{"expression": "'A' ILIKE 'A'", "returns": "TRUE"}, {
            "expression": "'A' ILIKE 'a'",
            "returns": "TRUE"
        }, {"expression": "'A' ILIKE 'B'", "returns": "FALSE"}, {
            "expression": "'ABC' ILIKE 'b'",
            "returns": "FALSE"
        }, {"expression": "'ABC' ILIKE 'B'", "returns": "FALSE"}, {
            "expression": "'ABC' ILIKE '_b_'",
            "returns": "TRUE"
        }, {"expression": "'ABC' ILIKE '_B_'", "returns": "TRUE"}, {
            "expression": "'ABCD' ILIKE '_b_'",
            "returns": "FALSE"
        }, {"expression": "'ABCD' ILIKE '_B_'", "returns": "FALSE"}, {
            "expression": "'ABCD' ILIKE '_b%'",
            "returns": "TRUE"
        }, {"expression": "'ABCD' ILIKE '_B%'", "returns": "TRUE"}, {
            "expression": "'ABCD' ILIKE '%b%'",
            "returns": "TRUE"
        }, {"expression": "'ABCD' ILIKE '%B%'", "returns": "TRUE"}, {
            "expression": "'ABCD%' ILIKE 'abcd\\\\\\\\%'",
            "returns": "TRUE"
        }, {"expression": "'ABCD' ILIKE '%B\\\\\\\\%'", "returns": "FALSE"}],
        "tags": ["compare", "numbers", "insensitive", "first", "match", "sensitive", "supplied", "parameter", "case", "matches", "pattern"]
    }, {
        "name": "ILIKE",
        "type": "operator",
        "groups": ["Operators"],
        "description": "如果第一个参数与提供的模式不区分大小写匹配,则返回 TRUE。可以使用 LIKE 代替 ILIKE 使匹配区分大小写。也适用于数字。",
        "arguments": [{"arg": "string\/number", "description": "要搜索的字符串"}, {
            "arg": "pattern",
            "description": "要查找的模式,您可以使用 '%' 作为通配符,'_' 作为单个字符,'\\\\\\\\' 来转义这些特殊字符。"
        }],
        "examples": [{"expression": "'A' ILIKE 'A'", "returns": "TRUE"}, {
            "expression": "'A' ILIKE 'a'",
            "returns": "TRUE"
        }, {"expression": "'A' ILIKE 'B'", "returns": "FALSE"}, {
            "expression": "'ABC' ILIKE 'b'",
            "returns": "FALSE"
        }, {"expression": "'ABC' ILIKE 'B'", "returns": "FALSE"}, {
            "expression": "'ABC' ILIKE '_b_'",
            "returns": "TRUE"
        }, {"expression": "'ABC' ILIKE '_B_'", "returns": "TRUE"}, {
            "expression": "'ABCD' ILIKE '_b_'",
            "returns": "FALSE"
        }, {"expression": "'ABCD' ILIKE '_B_'", "returns": "FALSE"}, {
            "expression": "'ABCD' ILIKE '_b%'",
            "returns": "TRUE"
        }, {"expression": "'ABCD' ILIKE '_B%'", "returns": "TRUE"}, {
            "expression": "'ABCD' ILIKE '%b%'",
            "returns": "TRUE"
        }, {"expression": "'ABCD' ILIKE '%B%'", "returns": "TRUE"}, {
            "expression": "'ABCD%' ILIKE 'abcd\\\\\\\\%'",
            "returns": "TRUE"
        }, {"expression": "'ABCD' ILIKE '%B\\\\\\\\%'", "returns": "FALSE"}],
        "tags": ["compare", "numbers", "insensitive", "first", "match", "sensitive", "supplied", "parameter", "case", "matches", "pattern"]
    }], [{
        "name": "IS NOT",
        "type": "operator",
        "groups": ["Operators"],
        "description": "Returns TRUE if a is not the same as b.",
        "arguments": [{"arg": "a", "description": "value"}, {"arg": "b", "description": "value"}],
        "examples": [{"expression": "'a' IS NOT 'b'", "returns": "TRUE"}, {
            "expression": "'a' IS NOT 'a'",
            "returns": "FALSE"
        }, {"expression": "4 IS NOT 2+2", "returns": "FALSE"}],
        "tags": ["compare", "same", "different"]
    }, {
        "name": "IS NOT",
        "type": "operator",
        "groups": ["Operators"],
        "description": "如果 a 与 b 不同,则返回 TRUE。",
        "arguments": [{"arg": "a", "description": "value"}, {"arg": "b", "description": "value"}],
        "examples": [{"expression": "'a' IS NOT 'b'", "returns": "TRUE"}, {
            "expression": "'a' IS NOT 'a'",
            "returns": "FALSE"
        }, {"expression": "4 IS NOT 2+2", "returns": "FALSE"}],
        "tags": ["compare", "same", "different"]
    }], [{
        "name": "BETWEEN",
        "type": "operator",
        "groups": ["Operators"],
        "description": "Returns TRUE if value is within the specified range. The range is considered inclusive of the bounds. To test for exclusion NOT BETWEEN can be used.",
        "arguments": [{
            "arg": "value",
            "description": "the value to compare with a range. It can be a string, a number or a date."
        }, {"arg": "lower_bound AND higher_bound", "description": "range bounds"}],
        "examples": [{"expression": "'B' BETWEEN 'A' AND 'C'", "returns": "TRUE"}, {
            "expression": "2 BETWEEN 1 AND 3",
            "returns": "TRUE"
        }, {"expression": "2 BETWEEN 2 AND 3", "returns": "TRUE"}, {
            "expression": "'B' BETWEEN 'a' AND 'c'",
            "returns": "FALSE"
        }, {"expression": "lower('B') BETWEEN 'a' AND 'b'", "returns": "TRUE"}],
        "notes": "<i>value BETWEEN lower_bound AND higher_bound<\/i> is the same as \"<i>value &gt;= lower_bound AND value &lt;= higher_bound<\/i>\".",
        "tags": ["bound", "contained", "found", "include", "range", "within"]
    }, {
        "name": "BETWEEN",
        "type": "operator",
        "groups": ["Operators"],
        "description": "如果值在指定范围内,则返回 TRUE。范围被视为包含边界。要测试排除,可以使用 NOT BETWEEN。",
        "arguments": [{
            "arg": "value",
            "description": "要与范围进行比较的值。它可以是字符串、数字或日期。"
        }, {"arg": "lower_bound AND higher_bound", "description": "范围界限"}],
        "examples": [{"expression": "'B' BETWEEN 'A' AND 'C'", "returns": "TRUE"}, {
            "expression": "2 BETWEEN 1 AND 3",
            "returns": "TRUE"
        }, {"expression": "2 BETWEEN 2 AND 3", "returns": "TRUE"}, {
            "expression": "'B' BETWEEN 'a' AND 'c'",
            "returns": "FALSE"
        }, {"expression": "lower('B') BETWEEN 'a' AND 'b'", "returns": "TRUE"}],
        "tags": ["bound", "contained", "found", "include", "range", "within"]
    }], [{
        "name": "NOT BETWEEN",
        "type": "operator",
        "groups": ["Operators"],
        "description": "Returns TRUE if value is not within the specified range. The range is considered inclusive of the bounds.",
        "arguments": [{
            "arg": "value",
            "description": "the value to compare with a range. It can be a string, a number or a date."
        }, {"arg": "lower_bound AND higher_bound", "description": "range bounds"}],
        "examples": [{
            "expression": "'B' NOT BETWEEN 'A' AND 'C'",
            "returns": "FALSE"
        }, {"expression": "1.0 NOT BETWEEN 1.1 AND 1.2", "returns": "TRUE"}, {
            "expression": "2 NOT BETWEEN 2 AND 3",
            "returns": "FALSE"
        }, {
            "expression": "'B' NOT BETWEEN 'a' AND 'c'",
            "returns": "TRUE"
        }, {"expression": "lower('B') NOT BETWEEN 'a' AND 'b'", "returns": "FALSE"}],
        "notes": "<i>value NOT BETWEEN lower_bound AND higher_bound<\/i> is the same as \"<i>value &lt; lower_bound OR value &gt; higher_bound<\/i>\".",
        "tags": ["bound", "contained", "exclude", "found", "range"]
    }, {
        "name": "NOT BETWEEN",
        "type": "operator",
        "groups": ["Operators"],
        "description": "如果值不在指定范围内,则返回 TRUE。范围被视为包含边界。",
        "arguments": [{
            "arg": "value",
            "description": "要与范围进行比较的值。它可以是字符串、数字或日期。"
        }, {"arg": "lower_bound 和 higher_bound", "description": "范围界限"}],
        "examples": [{
            "expression": "'B' NOT BETWEEN 'A' AND 'C'",
            "returns": "FALSE"
        }, {"expression": "1.0 NOT BETWEEN 1.1 AND 1.2", "returns": "TRUE"}, {
            "expression": "2 NOT BETWEEN 2 AND 3",
            "returns": "FALSE"
        }, {
            "expression": "'B' NOT BETWEEN 'a' AND 'c'",
            "returns": "TRUE"
        }, {"expression": "lower('B') NOT BETWEEN 'a' AND 'b'", "returns": "FALSE"}],
        "tags": ["bound", "contained", "exclude", "found", "range"]
    }]]
}, {
    "title": "数学计算",
    "children": [[{
        "name": "abs",
        "type": "function",
        "groups": ["Math"],
        "description": "Returns the absolute value of a number.",
        "method": "Math.abs(value) ",
        "arguments": [{"arg": "value", "description": "a number"}],
        "examples": [{"expression": "Math.abs(-2)", "returns": "2"}],
        "tags": ["absolute"]
    }, {
        "name": "abs",
        "type": "function",
        "groups": ["Math"],
        "description": "返回一个数字的绝对值。",
        "method": "Math.abs(value) ",
        "arguments": [{"arg": "value", "description": "一个数字"}],
        "examples": [{"expression": "Math.abs(-2)", "returns": "2"}],
        "tags": ["absolute"]
    }], [{
        "name": "acos",
        "type": "function",
        "groups": ["Math"],
        "description": "Returns the inverse cosine of a value in radians.",
        "method": "Math.acos(value) ",
        "arguments": [{"arg": "value", "description": "cosine of an angle in radians"}],
        "examples": [{"expression": "Math.acos(0.5)", "returns": "1.0471975511966"}],
        "tags": ["angle", "cosine", "inverse", "radians"]
    }, {
        "name": "acos",
        "type": "function",
        "groups": ["Math"],
        "description": "以弧度返回某个值的反余弦值。",
        "method": "Math.acos(value) ",
        "arguments": [{"arg": "value", "description": "以弧度表示的角度的余弦值"}],
        "examples": [{"expression": "Math.acos(0.5)", "returns": "1.0471975511966"}],
        "tags": ["angle", "cosine", "inverse", "radians"]
    }], [{
        "name": "asin",
        "type": "function",
        "groups": ["Math"],
        "description": "Returns the inverse sine of a value in radians.",
        "method": "Math.asin(value) ",
        "arguments": [{"arg": "value", "description": "sine of an angle in radians"}],
        "examples": [{"expression": "Math.asin(1.0)", "returns": "1.5707963267949"}],
        "tags": ["sine", "inverse", "angle", "radians"]
    }, {
        "name": "asin",
        "type": "function",
        "groups": ["Math"],
        "description": "以弧度返回某个值的反正弦值。",
        "method": "Math.asin(value) ",
        "arguments": [{"arg": "value", "description": "以弧度返回某个值的反正弦值。"}],
        "examples": [{"expression": "Math.asin(1.0)", "returns": "1.5707963267949"}],
        "tags": ["sine", "inverse", "angle", "radians"]
    }], [{
        "name": "atan",
        "type": "function",
        "groups": ["Math"],
        "description": "Returns the inverse tangent of a value in radians.",
        "method": "Math.atan(value) ",
        "arguments": [{"arg": "value", "description": "tan of an angle in radians"}],
        "examples": [{"expression": "Math.atan(0.5)", "returns": "0.463647609000806"}],
        "tags": ["tangent", "inverse", "angle", "radians"]
    }, {
        "name": "atan",
        "type": "function",
        "groups": ["Math"],
        "description": "返回以弧度表示的值的反正切值。",
        "method": "Math.atan(value) ",
        "arguments": [{"arg": "value", "description": "以弧度表示的角度的正切值"}],
        "examples": [{"expression": "Math.atan(0.5)", "returns": "0.463647609000806"}],
        "tags": ["tangent", "inverse", "angle", "radians"]
    }], [{
        "name": "atan2",
        "type": "function",
        "groups": ["Math"],
        "description": "Returns the inverse tangent of dy\/dx by using the signs of the two arguments to determine the quadrant of the result.",
        "method": "Math.atan2(dy,dx) ",
        "arguments": [{"arg": "dy", "description": "y coordinate difference"}, {
            "arg": "dx",
            "description": "x coordinate difference"
        }],
        "examples": [{"expression": "Math.atan2(1.0, 1.732)", "returns": "0.523611477769969"}],
        "tags": ["tangent", "arguments", "signs", "angle", "inverse", "quadrant"]
    }, {
        "name": "atan2",
        "type": "function",
        "groups": ["Math"],
        "description": "使用两个参数的符号确定结果的象限,返回 dy\/dx 的反正切值。",
        "method": "Math.atan2(dy,dx) ",
        "arguments": [{"arg": "dy", "description": "y 坐标差值"}, {"arg": "dx", "description": "x 坐标差值"}],
        "examples": [{"expression": "Math.atan2(1.0, 1.732)", "returns": "0.523611477769969"}],
        "tags": ["tangent", "arguments", "signs", "angle", "inverse", "quadrant"]
    }], [{
        "name": "ceil",
        "type": "function",
        "groups": ["Math"],
        "description": "Rounds a number upwards.",
        "method": "Math.ceil(value) ",
        "arguments": [{"arg": "value", "description": "a number"}],
        "examples": [{"expression": "Math.ceil(4.9)", "returns": "5"}, {
            "expression": "Math.ceil(-4.9)",
            "returns": "-4"
        }],
        "tags": ["rounds", "number"]
    }, {
        "name": "ceil",
        "type": "function",
        "groups": ["Math"],
        "description": "向上舍入数字。",
        "method": "Math.ceil(value) ",
        "arguments": [{"arg": "value", "description": "一个数字"}],
        "examples": [{"expression": "Math.ceil(4.9)", "returns": "5"}, {
            "expression": "Math.ceil(-4.9)",
            "returns": "-4"
        }],
        "tags": ["rounds", "number"]
    }], [{
        "name": "cos",
        "type": "function",
        "groups": ["Math"],
        "description": "Returns the inverse cosine of a value in radians.",
        "method": "Math.cos(value)",
        "arguments": [{"arg": "value", "description": "cosine of an angle in radians"}],
        "examples": [{"expression": "Math.cos(0.5)", "returns": "1.0471975511966"}],
        "tags": ["angle", "cosine", "inverse", "radians"]
    }, {
        "name": "cos",
        "type": "function",
        "groups": ["Math"],
        "description": "以弧度返回某个值的反余弦值。",
        "method": "Math.cos(value)",
        "arguments": [{"arg": "value", "description": "以弧度表示的角度的余弦值"}],
        "examples": [{"expression": "Math.cos(0.5)", "returns": "1.0471975511966"}],
        "tags": ["angle", "cosine", "inverse", "radians"]
    }], [{
        "name": "degrees",
        "type": "function",
        "groups": ["Math"],
        "description": "Converts from radians to degrees.",
        "method": "Math.degrees(radians) ",
        "arguments": [{"arg": "radians", "description": "numeric value"}],
        "examples": [{"expression": "Math.degrees(3.14159)", "returns": "180"}, {
            "expression": "Math.degrees(1)",
            "returns": "57.2958"
        }],
        "tags": ["converts", "degrees", "radians"]
    }, {
        "name": "degrees",
        "type": "function",
        "groups": ["Math"],
        "description": "将弧度转换为度。",
        "method": "Math.degrees(radians) ",
        "arguments": [{"arg": "radians", "description": "numeric value"}],
        "examples": [{"expression": "Math.degrees(3.14159)", "returns": "180"}, {
            "expression": "Math.degrees(1)",
            "returns": "57.2958"
        }],
        "tags": ["converts", "degrees", "radians"]
    }], [{
        "name": "exp",
        "type": "function",
        "groups": ["Math"],
        "description": "Returns exponential of an value.",
        "method": "Math.exp(value) ",
        "arguments": [{"arg": "value", "description": "number to return exponent of"}],
        "examples": [{"expression": "Math.exp(1.0)", "returns": "2.71828182845905"}],
        "tags": ["exponential"]
    }, {
        "name": "exp",
        "type": "function",
        "groups": ["Math"],
        "description": "返回e的x次方值，ex，即e的x次幂。这里e代表自然对数的底数，其近似为2.71828。",
        "method": "Math.exp(value) ",
        "arguments": [{"arg": "value", "description": "指数的数字"}],
        "examples": [{"expression": "Math.exp(1.0)", "returns": "2.71828182845905"}],
        "tags": ["exponential"]
    }], [{
        "name": "floor",
        "type": "function",
        "groups": ["Math"],
        "description": "Rounds a number downwards.",
        "method": "Math.floor(value) ",
        "arguments": [{"arg": "value", "description": "a number"}],
        "examples": [{"expression": "Math.floor(4.9)", "returns": "4"}, {
            "expression": "Math.floor(-4.9)",
            "returns": "-5"
        }],
        "tags": ["downwards", "rounds", "number"]
    }, {
        "name": "floor",
        "type": "function",
        "groups": ["Math"],
        "description": "向下舍入数字。",
        "method": "Math.floor(value) ",
        "arguments": [{"arg": "value", "description": "一个数字"}],
        "examples": [{"expression": "Math.floor(4.9)", "returns": "4"}, {
            "expression": "Math.floor(-4.9)",
            "returns": "-5"
        }],
        "tags": ["downwards", "rounds", "number"]
    }], [{
        "name": "ln",
        "type": "function",
        "groups": ["Math"],
        "description": "Returns the natural logarithm of a value.",
        "method": "Math.ln(value) ",
        "arguments": [{"arg": "value", "description": "numeric value"}],
        "examples": [{"expression": "Math.ln(1)", "returns": "0"}, {
            "expression": "ln(2.7182818284590452354)",
            "returns": "1"
        }],
        "tags": ["natural", "logarithm"]
    }, {
        "name": "ln",
        "type": "function",
        "groups": ["Math"],
        "description": "LN返回某个数字的自然对数。自然对数基于常数e(2.71828182845904)。",
        "method": "Math.ln(value) ",
        "arguments": [{"arg": "value", "description": "numeric value"}],
        "examples": [{"expression": "Math.ln(1)", "returns": "0"}, {
            "expression": "ln(2.7182818284590452354)",
            "returns": "1"
        }],
        "tags": ["natural", "logarithm"]
    }], [{
        "name": "log",
        "type": "function",
        "groups": ["Math"],
        "description": "Returns the value of the logarithm of the passed value and base.",
        "method": "Math.log(base,value) ",
        "arguments": [{"arg": "base", "description": "any positive number"}, {
            "arg": "value",
            "description": "any positive number"
        }],
        "examples": [{"expression": "Math.log(2, 32)", "returns": "5"}, {
            "expression": "Math.log(0.5, 32)",
            "returns": "-5"
        }],
        "tags": ["base", "logarithm"]
    }, {
        "name": "log",
        "type": "function",
        "groups": ["Math"],
        "description": "返回传递的值和底数的对数值。",
        "method": "Math.log(base,value) ",
        "arguments": [{"arg": "base", "description": "底数，任意正数"}, {"arg": "value", "description": "值，任意正数"}],
        "examples": [{"expression": "Math.log(2, 32)", "returns": "5"}, {
            "expression": "Math.log(0.5, 32)",
            "returns": "-5"
        }],
        "tags": ["base", "logarithm"]
    }], [{
        "name": "max",
        "type": "function",
        "groups": ["Math"],
        "description": "Returns the largest value in a set of values.",
        "method": "Math.max(value1,value2,value) ",
        "variableLenArguments": true,
        "arguments": [{"arg": "value1", "syntaxOnly": true}, {"arg": "value2", "syntaxOnly": true}, {
            "arg": "value",
            "descOnly": true,
            "description": "a number"
        }],
        "examples": [{
            "expression": "Math.max(2,10.2,5.5)",
            "returns": "10.2"
        }, {"expression": "Math.max(20.5,NULL,6.2)", "returns": "20.5"}],
        "tags": ["longest", "biggest", "most", "largest", "maximum"]
    }, {
        "name": "max",
        "type": "function",
        "groups": ["Math"],
        "description": "返回一组值中的最大值。",
        "method": "Math.max(value1,value2,value) ",
        "variableLenArguments": true,
        "arguments": [{"arg": "value1", "syntaxOnly": true, "description": "一个数字"}, {
            "arg": "value2",
            "syntaxOnly": true,
            "description": "一个数字"
        }, {"arg": "value", "descOnly": true, "description": "一个数字"}],
        "examples": [{
            "expression": "Math.max(2,10.2,5.5)",
            "returns": "10.2"
        }, {"expression": "Math.max(20.5,NULL,6.2)", "returns": "20.5"}],
        "tags": ["longest", "biggest", "most", "largest", "maximum"]
    }], [{
        "name": "min",
        "type": "function",
        "groups": ["Math"],
        "description": "Returns the smallest value in a set of values.",
        "method": "Math.min(value1,value2,value) ",
        "variableLenArguments": true,
        "arguments": [{"arg": "value1", "syntaxOnly": true}, {"arg": "value2", "syntaxOnly": true}, {
            "arg": "value",
            "descOnly": true,
            "description": "a number"
        }],
        "examples": [{"expression": "Math.min(20.5,10,6.2)", "returns": "6.2"}, {
            "expression": "Math.min(2,-10.3,NULL)",
            "returns": "-10.3"
        }],
        "tags": ["least", "smallest", "minimum"]
    }, {
        "name": "min",
        "type": "function",
        "groups": ["Math"],
        "description": "返回一组值中的最小值。",
        "method": "Math.min(value1,value2,value) ",
        "variableLenArguments": true,
        "arguments": [{"arg": "value1", "syntaxOnly": true, "description": "一个数字"}, {
            "arg": "value2",
            "syntaxOnly": true,
            "description": "一个数字"
        }, {"arg": "value", "descOnly": true, "description": "一个数字"}],
        "examples": [{"expression": "Math.min(20.5,10,6.2)", "returns": "6.2"}, {
            "expression": "Math.min(2,-10.3,NULL)",
            "returns": "-10.3"
        }],
        "tags": ["least", "smallest", "minimum"]
    }], [{
        "name": "pi",
        "type": "function",
        "groups": ["Math"],
        "description": "Returns value of pi for calculations.",
        "method": "Math.pi() ",
        "examples": [{"expression": "Mathpi()", "returns": "3.14159265358979"}],
        "tags": ["calculations", "pi"]
    }, {
        "name": "pi",
        "type": "function",
        "groups": ["Math"],
        "description": "返回 pi 的值以供计算。",
        "method": "Math.pi() ",
        "examples": [{"expression": "Math.pi()", "returns": "3.14159265358979"}],
        "tags": ["calculations", "pi"]
    }], [{
        "name": "random",
        "type": "function",
        "groups": ["Math"],
        "description": "Returns a random integer within the range specified by the minimum and maximum argument (inclusive). If a seed is provided, the returned will always be the same, depending on the seed.",
        "method": "Math.random(<min>,<max>,<seed>) ",
        "arguments": [{
            "arg": "min",
            "description": "an integer representing the smallest possible random number desired"
        }, {
            "arg": "max",
            "description": "an integer representing the largest possible random number desired"
        }, {"arg": "seed", "optional": true, "default": "NULL", "description": "any value to use as seed"}],
        "examples": [{"expression": "Math.random(1, 10)", "returns": "8"}],
        "tags": ["random", "inclusive", "specified", "range", "argument", "seed", "same", "provided", "minimum", "maximum", "integer", "depending"]
    }, {
        "name": "random",
        "type": "function",
        "groups": ["Math"],
        "description": "返回随机数，由最小和最大参数（包括）指定的范围内的随机整数。如果提供了种子,则返回的值将始终相同,具体取决于种子。",
        "method": "Math.random(<min>,<max>,<seed>) ",
        "arguments": [{"arg": "min", "description": "表示所需的最小可能随机数的整数"}, {
            "arg": "max",
            "description": "表示所需的最大可能随机数的整数"
        }, {"arg": "seed", "optional": true, "default": "NULL", "description": "用作种子的任何值"}],
        "examples": [{"expression": "Math.random(1, 10)", "returns": "8"}],
        "tags": ["random", "inclusive", "specified", "range", "argument", "seed", "same", "provided", "minimum", "maximum", "integer", "depending"]
    }], [{
        "name": "round",
        "type": "function",
        "groups": ["Math"],
        "description": "Rounds a number to number of decimal places.",
        "method": "Math.round(value) ",
        "arguments": [{"arg": "value", "description": "decimal number to be rounded"}, {
            "arg": "places",
            "optional": true,
            "default": "0",
            "description": "Optional integer representing number of places to round decimals to. Can be negative."
        }],
        "examples": [{
            "expression": "Math.round(1234.567, 2)",
            "returns": "1234.57"
        }, {"expression": "Math.round(1234.567)", "returns": "1235"}, {
            "expression": "Math.round(1234.567, -1)",
            "returns": "1230"
        }],
        "tags": ["rounds", "places", "decimal", "number"]
    }, {
        "name": "round",
        "type": "function",
        "groups": ["Math"],
        "description": "将一个数字按照指定小数位四舍五入表示。",
        "method": "Math.round(value) ",
        "arguments": [{"arg": "value", "description": "要四舍五入的小数"}, {
            "arg": "places",
            "optional": true,
            "default": "0",
            "description": "可选整数,表示要将小数四舍五入到的位数。可以为负数。"
        }],
        "examples": [{
            "expression": "Math.round(1234.567, 2)",
            "returns": "1234.57"
        }, {"expression": "Math.round(1234.567)", "returns": "1235"}, {
            "expression": "Math.round(1234.567, -1)",
            "returns": "1230"
        }],
        "tags": ["rounds", "places", "decimal", "number"]
    }], [{
        "name": "sin",
        "type": "function",
        "groups": ["Math"],
        "description": "Returns the inverse sine of a value in radians.",
        "method": "Math.sin(value) ",
        "arguments": [{"arg": "value", "description": "sine of an angle in radians"}],
        "examples": [{"expression": "Math.sin(1.0)", "returns": "1.5707963267949"}],
        "tags": ["sine", "inverse", "angle", "radians"]
    }, {
        "name": "sin",
        "type": "function",
        "groups": ["Math"],
        "description": "以弧度返回某个值的反正弦值。",
        "method": "Math.sin(value) ",
        "arguments": [{"arg": "value", "description": "以弧度返回某个值的反正弦值。"}],
        "examples": [{"expression": "Math.sin(1.0)", "returns": "1.5707963267949"}],
        "tags": ["sine", "inverse", "angle", "radians"]
    }], [{
        "name": "sqrt",
        "type": "function",
        "groups": ["Math"],
        "description": "Returns square root of a value.",
        "method": "Math.sqrt(value) ",
        "arguments": [{"arg": "value", "description": "a number"}],
        "examples": [{"expression": "Math.sqrt(9)", "returns": "3"}],
        "tags": ["root", "square"]
    }, {
        "name": "sqrt",
        "type": "function",
        "groups": ["Math"],
        "description": "返回一个值的平方根。",
        "method": "Math.sqrt(value) ",
        "arguments": [{"arg": "value", "description": "一个数字。"}],
        "examples": [{"expression": "Math.sqrt(9)", "returns": "3"}],
        "tags": ["root", "square"]
    }], [{
        "name": "tan",
        "type": "function",
        "groups": ["Math"],
        "description": "Returns the tangent of an angle.",
        "method": "Math.tan(angle) ",
        "arguments": [{"arg": "angle", "description": "angle in radians"}],
        "examples": [{"expression": "Math.tan(1.0)", "returns": "1.5574077246549"}],
        "tags": ["angle", "tangent"]
    }, {
        "name": "tan",
        "type": "function",
        "groups": ["Math"],
        "description": "返回一个角度的正切值。",
        "method": "Math.tan(angle) ",
        "arguments": [{"arg": "angle", "description": "角度（弧度）"}],
        "examples": [{"expression": "Math.tan(1.0)", "returns": "1.5574077246549"}],
        "tags": ["angle", "tangent"]
    }]]
}, {
    "title": "字符串",
    "children": [[{
        "name": "charCodeAt",
        "type": "function",
        "groups": ["String"],
        "description": "Returns the unicode encoding of the character in the string.",
        "arguments": [{"arg": "char", "description": "The character to be converted in the string."}],
        "examples": [{"expression": "'Bigemap'.charCodeAt('B')", "returns": "66"}],
        "tags": ["code", "first", "associated", "character", "unicode"]
    }, {
        "name": "charCodeAt",
        "type": "function",
        "groups": ["String"],
        "description": "返回字符串中的字符 unicode编码。",
        "arguments": [{"arg": "char", "description": "字符串中要转换的字符。"}],
        "examples": [{"expression": "'Bigemap'.charCodeAt('B')", "returns": "66"}],
        "tags": ["code", "first", "associated", "character", "unicode"]
    }], [{
        "name": "concat",
        "type": "function",
        "groups": ["String"],
        "description": "Used to concatenate two or more strings and return a new string..",
        "method": "string.concat(string1,string2,..., stringX)",
        "arguments": [{
            "arg": "string1，string2...",
            "description": "Returns a new string generated by concatenating all string arguments in the concat() method call."
        }],
        "examples": [{"expression": "'Hello'.concat(' World!')", "returns": "'Hello world!'"}],
        "tags": ["concat", "string", "array", "supplied", "map"]
    }, {
        "name": "concat",
        "type": "function",
        "groups": ["String"],
        "description": "用于连接两个或多个字符串,并返回新的字符串。",
        "method": "string.concat(string1,string2,..., stringX)",
        "arguments": [{
            "arg": "string, string2...",
            "description": "返回一个新的字符串,该字符串是通过把 concat() 的方法调用中的所有字符串参数连接在一起生成的。"
        }],
        "examples": [{"expression": "'Hello'.concat(' World!')", "returns": "'Hello world!'"}],
        "tags": ["concat", "string", "array", "supplied", "map"]
    }], [{
        "name": "format",
        "type": "function",
        "groups": ["String"],
        "description": "Format a string using supplied arguments.",
        "variableLenArguments": true,
        "arguments": [{
            "arg": "string",
            "description": "A string with placeholders %1, %2, etc., for the arguments. Placeholders can be repeated. The lowest numbered placeholder is replaced by arg1, the next by arg2, etc."
        }, {"arg": "arg1", "syntaxOnly": true}, {"arg": "arg2", "syntaxOnly": true}, {
            "arg": "arg",
            "descOnly": true,
            "description": "any type. Any number of arguments."
        }],
        "examples": [{
            "expression": "format('This %1 a %2','is', 'software')",
            "returns": "'This is a software'"
        }, {
            "expression": "format('This is %2','a bit unexpected but 2 is lowest number in string','normal')",
            "returns": "'This is a bit unexpected but 2 is lowest number in string'"
        }],
        "tags": ["format", "supplied", "arguments"]
    }, {
        "name": "format",
        "type": "function",
        "groups": ["String"],
        "description": "使用提供的参数格式化字符串。",
        "variableLenArguments": true,
        "arguments": [{
            "arg": "string",
            "description": "带有占位符 %1、%2 等的字符串,用于参数。占位符可以重复。编号最小的占位符由 arg1 替换,下一个由 arg2 替换,等等。"
        }, {"arg": "arg1", "syntaxOnly": true}, {"arg": "arg2", "syntaxOnly": true}, {
            "arg": "arg",
            "descOnly": true,
            "description": "任何类型。任意数量的参数。"
        }],
        "examples": [{
            "expression": "format('This %1 a %2','is', 'software')",
            "returns": "'This is a software'"
        }, {
            "expression": "format('This is %2','a bit surprise but 2 is lowest number in string','normal')",
            "returns": "'This is a bit surprise but 2 is lowest number in string'"
        }],
        "tags": ["format", "supplied", "arguments"]
    }], [{
        "name": "format_date",
        "type": "function",
        "groups": ["String", "Date and Time"],
        "description": "Formats a date type or string into a custom string format. Uses date\/time format strings.",
        "arguments": [{"arg": "datetime", "description": "date, time or datetime value"}, {
            "arg": "format",
            "description": "String template used to format the string. <table><thead><tr><th>Expression<\/th><th>Output<\/th><\/tr><\/thead><tr valign=\"top\"><td>d<\/td><td>the day as number without a leading zero (1 to 31)<\/td><\/tr><tr valign=\"top\"><td>dd<\/td><td>the day as number with a leading zero (01 to 31)<\/td><\/tr><tr valign=\"top\"><td>ddd<\/td><td>the abbreviated localized day name (e.g. 'Mon' to 'Sun')<\/td><\/tr><tr valign=\"top\"><td>dddd<\/td><td>the long localized day name (e.g. 'Monday' to 'Sunday')<\/td><\/tr><tr valign=\"top\"><td>M<\/td><td>the month as number without a leading zero (1-12)<\/td><\/tr><tr valign=\"top\"><td>MM<\/td><td>the month as number with a leading zero (01-12)<\/td><\/tr><tr valign=\"top\"><td>MMM<\/td><td>the abbreviated localized month name (e.g. 'Jan' to 'Dec')<\/td><\/tr><tr valign=\"top\"><td>MMMM<\/td><td>the long localized month name (e.g. 'January' to 'December')<\/td><\/tr><tr valign=\"top\"><td>yy<\/td><td>the year as two digit number (00-99)<\/td><\/tr><tr valign=\"top\"><td>yyyy<\/td><td>the year as four digit number<\/td><\/tr><\/table><p>These expressions may be used for the time part of the format string:<\/p><table><thead><tr><th>Expression<\/th><th>Output<\/th><\/tr><\/thead><tr valign=\"top\"><td>h<\/td><td>the hour without a leading zero (0 to 23 or 1 to 12 if AM\/PM display)<\/td><\/tr><tr valign=\"top\"><td>hh<\/td><td>the hour with a leading zero (00 to 23 or 01 to 12 if AM\/PM display)<\/td><\/tr><tr valign=\"top\"><td>H<\/td><td>the hour without a leading zero (0 to 23, even with AM\/PM display)<\/td><\/tr><tr valign=\"top\"><td>HH<\/td><td>the hour with a leading zero (00 to 23, even with AM\/PM display)<\/td><\/tr><tr valign=\"top\"><td>m<\/td><td>the minute without a leading zero (0 to 59)<\/td><\/tr><tr valign=\"top\"><td>mm<\/td><td>the minute with a leading zero (00 to 59)<\/td><\/tr><tr valign=\"top\"><td>s<\/td><td>the second without a leading zero (0 to 59)<\/td><\/tr><tr valign=\"top\"><td>ss<\/td><td>the second with a leading zero (00 to 59)<\/td><\/tr><tr valign=\"top\"><td>z<\/td><td>the milliseconds without trailing zeroes (0 to 999)<\/td><\/tr><tr valign=\"top\"><td>zzz<\/td><td>the milliseconds with trailing zeroes (000 to 999)<\/td><\/tr><tr valign=\"top\"><td>AP or A<\/td><td>interpret as an AM\/PM time. <i>AP<\/i> must be either 'AM' or 'PM'.<\/td><\/tr><tr valign=\"top\"><td>ap or a<\/td><td>Interpret as an AM\/PM time. <i>ap<\/i> must be either 'am' or 'pm'.<\/td><\/tr><\/table>"
        }, {
            "arg": "language",
            "optional": true,
            "description": "language (lowercase, two- or three-letter, ISO 639 language code) used to format the date into a custom string. By default the current user locale is used."
        }],
        "examples": [{
            "expression": "format_date('2012-05-15','dd.MM.yyyy')",
            "returns": "'15.05.2012'"
        }, {
            "expression": "format_date('2012-05-15','d MMMM yyyy','fr')",
            "returns": "'15 mai 2012'"
        }, {
            "expression": "format_date('2012-05-15','dddd')",
            "returns": "'Tuesday', if the current locale is an English variant"
        }, {
            "expression": "format_date('2012-05-15 13:54:20','dd.MM.yy')",
            "returns": "'15.05.12'"
        }, {"expression": "format_date('13:54:20','hh:mm AP')", "returns": "'01:54 PM'"}],
        "tags": ["custom", "type", "uses", "format", "strings", "time", "date", "formats", "see", "qdatetime", "tostring"]
    }, {
        "name": "format_date",
        "type": "function",
        "groups": ["String", "Date and Time"],
        "description": "将日期类型或字符串格式化为自定义字符串格式。使用 Qt 日期\/时间格式字符串。",
        "arguments": [{"arg": "datetime", "description": "日期、时间或日期时间值"}, {
            "arg": "format",
            "description": "用于格式化字符串的字符串模板。<table><thead><tr><th>表达式<\/th><th>输出<\/th><\/tr><\/thead><tr valign=\"top\"><td>d<\/td><td>以数字形式表示的日期,不带前导零（1 到 31）<\/td><\/tr><tr valign=\"top\"><td>dd<\/td><td>以数字形式表示的日期,前导零为 0（01 至 31）<\/td><\/tr><tr valign=\"top\"><td>ddd<\/td><td>缩写的本地化日期名称（例如 'Mon' 至 'Sun'）<\/td><\/tr><tr valign=\"top\"><td>dddd<\/td><td>较长的本地化日期名称（例如 'Monday' 至 'Sunday'）<\/td><\/tr><tr valign=\"top\"><td>M<\/td><td>以数字形式表示的月份,前导零为 1-12）<\/td><\/tr><tr valign=\"top\"><td>MM<\/td><td>以数字形式表示的月份,前导零为 0（01-12）<\/td><\/tr><tr valign=\"top\"><td>MMM<\/td><td>缩写的本地化月份名称（例如'Jan' 到 'Dec')<\/td><\/tr><tr valign=\"top\"><td>MMMM<\/td><td>较长的本地化月份名称（例如 'January' 到 'December'）<\/td><\/tr><tr valign=\"top\"><td>yy<\/td><td>两位数表示的年份 (00-99)<\/td><\/tr><tr valign=\"top\"><td>yyyy<\/td><td>四位数表示的年份<\/td><\/tr><\/table><p>这些表达式可用于格式字符串的时间部分：<\/p><table><thead><tr><th>表达式<\/th><th>输出<\/th><\/tr><\/thead><tr valign=\"top\"><td>h<\/td><td>不带前导零的小时数（如果是 AM\/PM,则为 0 到 23 或 1 到 12显示)<\/td><\/tr><tr valign=\"top\"><td>hh<\/td><td>带有前导零的小时 (如果显示 AM\/PM,则为 00 至 23 或 01 至 12)<\/td><\/tr><tr valign=\"top\"><td>H<\/td><td>不带前导零的小时 (0 至 23,即使显示 AM\/PM)<\/td><\/tr><tr valign=\"top\"><td>HH<\/td><td>带有前导零的小时 (00 至 23,即使显示 AM\/PM)<\/td><\/tr><tr valign=\"top\"><td>m<\/td><td>不带前导零的分钟 (0 至 59)<\/td><\/tr><tr valign=\"top\"><td>mm<\/td><td>带有前导零的分钟 (00 至 59)<\/td><\/tr><tr valign=\"top\"><td>s<\/td><td>没有前导零的秒（0 到 59）<\/td><\/tr><tr valign=\"top\"><td>ss<\/td><td>带有前导零的秒（00 到 59）<\/td><\/tr><tr valign=\"top\"><td>z<\/td><td>没有尾随零的毫秒（0 到 999）<\/td><\/tr><tr valign=\"top\"><td>zzz<\/td><td>带有尾随零的毫秒（000 到 999）<\/td><\/tr><tr valign=\"top\"><td>AP 或 A<\/td><td>解释为 AM\/PM 时间。 <i>AP<\/i> 必须是 'AM' 或 'PM'。<\/td><\/tr><tr valign=\"top\"><td>ap 或 a<\/td><td>解释为 AM\/PM 时间。<i>ap<\/i> 必须是 'am' 或 'pm'。<\/td><\/tr><\/table>"
        }, {
            "arg": "language",
            "optional": true,
            "description": "language（小写、两个或三个字母、ISO 639 语言代码）用于将日期格式化为自定义字符串。默认情况下,使用当前用户区域设置。"
        }],
        "examples": [{
            "expression": "format_date('2012-05-15','dd.MM.yyyy')",
            "returns": "'15.05.2012'"
        }, {
            "expression": "format_date('2012-05-15','d MMMM yyyy','fr')",
            "returns": "'15 mai 2012'"
        }, {
            "expression": "format_date('2012-05-15','dddd')",
            "returns": "'Tuesday', 如果当前区域设置是英语变体"
        }, {
            "expression": "format_date('2012-05-15 13:54:20','dd.MM.yy')",
            "returns": "'15.05.12'"
        }, {"expression": "format_date('13:54:20','hh:mm AP')", "returns": "'01:54 PM'"}],
        "tags": ["custom", "type", "uses", "format", "strings", "time", "date", "formats", "see", "qdatetime", "tostring"]
    }], [{
        "name": "fromCharCode",
        "type": "function",
        "groups": ["String"],
        "description": "Returns the character associated with a unicode code.",
        "arguments": [{"arg": "code", "description": "a unicode code number"}],
        "examples": [{"expression": "String.fromCharCode(66)", "returns": "'B'"}],
        "tags": ["associated", "character", "unicode", "code"]
    }, {
        "name": "fromCharCode",
        "type": "function",
        "groups": ["String"],
        "description": "返回与 Unicode 代码关联的字符。",
        "arguments": [{"arg": "code", "description": "Unicode 代码编号"}],
        "examples": [{"expression": "String.fromCharCode(66)", "returns": "'B'"}],
        "tags": ["associated", "character", "unicode", "code"]
    }], [{
        "name": "indexOf",
        "type": "function",
        "groups": ["String"],
        "description": "Return the first matching position of a substring within another string, or 0 if the substring is not found.",
        "arguments": [{"arg": "haystack", "description": "string that is to be searched"}, {
            "arg": "needle",
            "description": "string to search for"
        }],
        "examples": [{
            "expression": "'HELLO WORLD'.indexOf('WORLD')",
            "returns": "7"
        }, {"expression": "'HELLO WORLD'.indexOf('GOODBYE')", "returns": "0"}],
        "tags": ["substring", "position", "return", "found", "first", "matching"]
    }, {
        "name": "indexOf",
        "type": "function",
        "groups": ["String"],
        "description": "返回子字符串在另一个字符串中的第一个匹配位置,如果未找到子字符串,则返回 0。",
        "arguments": [{"arg": "haystack", "description": "被搜索的字符串"}, {
            "arg": "needle",
            "description": "要搜索的字符串"
        }],
        "examples": [{
            "expression": "'HELLO WORLD'.indexOf('WORLD')",
            "returns": "7"
        }, {"expression": "'HELLO WORLD'.indexOf('GOODBYE')", "returns": "0"}],
        "tags": ["substring", "position", "return", "found", "first", "matching"]
    }], [{
        "name": "length",
        "type": "function",
        "groups": ["String"],
        "description": "Returns the number of characters in a string or the length of a geometry linestring.",
        "arguments": [{"arg": "string", "description": "string to count length of"}],
        "examples": [{"expression": "'hello'.length", "returns": "5"}],
        "tags": ["distance", "linestring", "length", "count", "characters", "planimetric"]
    }, {
        "name": "length",
        "type": "function",
        "groups": ["String", "GeometryGroup"],
        "description": "返回字符串中的字符数或几何线串的长度。",
        "arguments": [{"arg": "string", "description": "要计算长度的字符串"}],
        "examples": [{"expression": "'hello'.length", "returns": "5"}],
        "tags": ["distance", "linestring", "length", "count", "characters", "planimetric"]
    }], [{
        "name": "replace",
        "type": "function",
        "groups": ["String"],
        "description": "Returns a string with the supplied string, array, or map of strings replaced.",
        "arguments": [{"arg": "string", "description": "the input string"}, {
            "arg": "before",
            "description": "the string or array of strings to replace"
        }, {"arg": "after", "description": "the string or array of strings to use as a replacement"}],
        "examples": [{"expression": "Bigemap SHOULD ROCK'.replace('SHOULD','DOES')", "returns": "'Bigemap DOES ROCK'"}],
        "tags": ["array", "map", "strings", "supplied", "replaced"]
    }, {
        "name": "replace",
        "type": "function",
        "groups": ["String"],
        "description": "返回一个字符串,其中提供的字符串、数组或字符串映射已被替换。",
        "arguments": [{"arg": "string", "description": "输入字符串"}, {
            "arg": "before",
            "description": "要替换的字符串或字符串数组"
        }, {"arg": "after", "description": "要用作替换的字符串或字符串数组"}],
        "examples": [{"expression": "Bigemap SHOULD ROCK'.replace('SHOULD','DOES')", "returns": "'Bigemap DOES ROCK'"}],
        "tags": ["array", "map", "strings", "supplied", "replaced"]
    }], [{
        "name": "slice",
        "type": "function",
        "groups": ["String"],
        "description": "Extract a part of a string and return a new string without changing the original string",
        "method": "string.slice(begin[, end])",
        "arguments": [{
            "arg": "begin",
            "description": "The index where the extraction starts (starting from 0)."
        }, {
            "arg": "end",
            "description": "Index where extraction ends (but not including the character at that point)."
        }],
        "examples": [{"expression": "'HELLO WORLD'.slice(0,5)", "returns": "'HELLO'"}],
        "tags": ["part"]
    }, {
        "name": "slice",
        "type": "function",
        "groups": ["String"],
        "description": "提取字符串的某个部分,并返回一个新的字符串,且不会改动原字符串。",
        "method": "string.slice(begin[, end])",
        "arguments": [{"arg": "begin", "description": "提取起始处的索引（从0开始）"}, {
            "arg": "end",
            "description": "提取结束处的索引（但该处的字符不包括在内）"
        }],
        "examples": [{"expression": "'HELLO WORLD'.slice(0,5)", "returns": "'HELLO'"}],
        "tags": ["part"]
    }], [{
        "name": "split",
        "type": "function",
        "groups": ["String"],
        "description": "Make a string array by dividing the string into substrings.",
        "method": "string.split(str)",
        "arguments": [{"arg": "str", "description": "symbol string to use for intervals"}],
        "examples": [{"expression": "'12+23+34'.split('+')", "returns": "'Array(12,23,34}'"}],
        "tags": ["split", "string", "array", "substring"]
    }, {
        "name": "split",
        "type": "function",
        "groups": ["String"],
        "description": "通过将字符串划分成子串,将一个字符串做成一个字符串数组。",
        "method": "string.split(str)",
        "arguments": [{"arg": "str", "description": "用于间隔的符号字符串"}],
        "examples": [{"expression": "'12+23+34'.split('+')", "returns": "'Array(12,23,34}'"}],
        "tags": ["split", "string", "array", "substring"]
    }], [{
        "name": "substr",
        "type": "function",
        "groups": ["String"],
        "description": "Extracts a specified number of characters from a string starting at a starting index.",
        "method": "string.substr(start[, length])",
        "arguments": [{
            "arg": "start",
            "description": "integer representing start position to extract beginning with 1; if start is negative, the return string will begin at the end of the string minus the start value"
        }, {
            "arg": "length",
            "optional": true,
            "description": "integer representing length of string to extract; if length is negative, the return string will omit the given length of characters from the end of the string"
        }],
        "examples": [{
            "expression": "'HELLO WORLD'.substring(3,5)",
            "returns": "'LLO W'"
        }, {
            "expression": "'HELLO WORLD'.substring(6)",
            "returns": "' WORLD'"
        }, {
            "expression": "'HELLO WORLD'.substring('-5)",
            "returns": "'WORLD'"
        }, {"expression": "'HELLO'.substring(3,-1)", "returns": "'LL'"}, {
            "expression": "'HELLO WORLD'.substring(-5,2)",
            "returns": "'WO'"
        }, {"expression": "'HELLO WORLD'.substring(-5,-1)", "returns": "'WORL'"}],
        "tags": ["part"]
    }, {
        "name": "substr",
        "type": "function",
        "groups": ["String"],
        "description": "从起始索引号提取字符串中指定数目的字符。",
        "method": "string.substr(start[, length])",
        "arguments": [{
            "arg": "start",
            "description": "表示从 1 开始提取的起始位置的整数；如果 start 为负数,则返回字符串将从字符串末尾减去起始值开始"
        }, {
            "arg": "length",
            "optional": true,
            "description": "表示要提取的字符串长度的整数；如果 length 为负数,则返回字符串将从字符串末尾省略给定长度的字符"
        }],
        "examples": [{
            "expression": "'HELLO WORLD'.substring(3,5)",
            "returns": "'LLO W'"
        }, {
            "expression": "'HELLO WORLD'.substring(6)",
            "returns": "' WORLD'"
        }, {
            "expression": "'HELLO WORLD'.substring('-5)",
            "returns": "'WORLD'"
        }, {"expression": "'HELLO'.substring(3,-1)", "returns": "'LL'"}, {
            "expression": "'HELLO WORLD'.substring(-5,2)",
            "returns": "'WO'"
        }, {"expression": "'HELLO WORLD'.substring(-5,-1)", "returns": "'WORL'"}],
        "tags": ["part"]
    }], [{
        "name": "substring",
        "type": "function",
        "groups": ["String"],
        "description": "Returns a part of  string which between two specified index numbers in a string.",
        "method": "string.substring(indexStart[, indexEnd])",
        "arguments": [{
            "arg": "indexStart",
            "description": "Required. A non-negative integer that specifies the position of the first character of the substring to be extracted in string."
        }, {
            "arg": "indexEnd",
            "optional": true,
            "description": "A non-negative integer that is one more than the position of the last character of the substring to be extracted in string. If this parameter is omitted, the substring continues to the end of string."
        }],
        "examples": [{
            "expression": "'HELLO WORLD'.substring(1,6)",
            "returns": "'ELLO W'"
        }, {"expression": "'HELLO WORLD'.substring(6)", "returns": "' WORLD'"}],
        "tags": ["string", "part", "", "length", "sub"]
    }, {
        "name": "substring",
        "type": "function",
        "groups": ["String"],
        "description": "返回字符串的一部分。",
        "arguments": [{"arg": "string", "description": "完整输入字符串"}, {
            "arg": "start",
            "description": "表示从 1 开始提取的起始位置的整数；如果 start 为负数,则返回字符串将从字符串末尾减去起始值开始"
        }, {
            "arg": "length",
            "optional": true,
            "description": "表示要提取的字符串长度的整数；如果 length 为负数,则返回字符串将从字符串末尾省略给定长度的字符"
        }],
        "examples": [{
            "expression": "'HELLO WORLD'.substring(1,6)",
            "returns": "'ELLO W'"
        }, {"expression": "'HELLO WORLD'.substring(6)", "returns": "' WORLD'"}],
        "tags": ["string", "part", "", "length", "sub"]
    }], [{
        "name": "toLocaleString",
        "type": "function",
        "groups": ["String"],
        "description": "Returns a number formatted with the locale separator for thousands. By default the current user locale is used. Also truncates the decimal places to the number of supplied places.",
        "arguments": [{"arg": "number,=10000000.332,2", "description": "number to be formatted"}],
        "examples": [{
            "expression": "number.toLocaleString()",
            "returns": "'10,000,000.33' if e.g. the current locale is an English variant"
        }],
        "tags": ["formatted", "truncates", "places", "separator", "decimal", "default", "thousands", "locale", "language"]
    }, {
        "name": "toLocaleString",
        "type": "function",
        "groups": ["String"],
        "description": "返回使用千位区域分隔符格式化的数字。默认情况下,使用当前用户区域设置。还将小数位数截断为提供的位数。",
        "arguments": [{"arg": "number,=10000000.332,2", "description": "要格式化的数字"}],
        "examples": [{
            "expression": "format_number(10000000.332,2)",
            "returns": "'10,000,000.33',例如,如果当前语言环境是英语"
        }],
        "tags": ["formatted", "truncates", "places", "separator", "decimal", "default", "thousands", "locale", "language"]
    }], [{
        "name": "toLowerCase",
        "type": "function",
        "groups": ["String"],
        "description": "Converts a string to lower case letters.",
        "arguments": [{"arg": "string", "description": "the string to convert to lower case"}],
        "examples": [{"expression": "'HELLO World'.toLowerCase()", "returns": "'hello world'"}],
        "tags": ["converts", "letters", "lower", "case"]
    }, {
        "name": "toLowerCase",
        "type": "function",
        "groups": ["String"],
        "description": "将字符串转换为小写字母。",
        "arguments": [{"arg": "string", "description": "要转换为小写字母的字符串"}],
        "examples": [{"expression": "'HELLO World'.toLowerCase()", "returns": "'hello world'"}],
        "tags": ["converts", "letters", "lower", "case"]
    }], [{
        "name": "toString",
        "type": "function",
        "groups": ["String"],
        "description": "Converts an object to a string.",
        "method": "object.toString()",
        "arguments": [{"arg": "", "description": "Returns a string."}],
        "examples": [{"expression": "123.tostring()", "returns": "'123'"}, {
            "expression": "arr[1,2,3].tobstring()",
            "returns": "'1,2,3'"
        }],
        "tags": ["string", "part", "", "length", "sub"]
    }, {
        "name": "toString",
        "type": "function",
        "groups": ["String"],
        "description": "将对象转换为字符串。",
        "method": "object.toString()",
        "arguments": [{"arg": "", "description": "返回字符串"}],
        "examples": [{"expression": "123.tostring()", "returns": "'123'"}, {
            "expression": "arr[1,2,3].tobstring()",
            "returns": "'1,2,3'"
        }],
        "tags": ["string", "part", "", "length", "sub"]
    }], [{
        "name": "toUpperCase",
        "type": "function",
        "groups": ["String"],
        "description": "Converts a string to upper case letters.",
        "arguments": [{"arg": "string", "description": "the string to convert to upper case"}],
        "examples": [{"expression": "'hello WOrld'.toUpperCase()", "returns": "'HELLO WORLD'"}],
        "tags": ["converts", "upper", "letters", "case"]
    }, {
        "name": "toUpperCase",
        "type": "function",
        "groups": ["String"],
        "description": "将字符串转换为大写字母。",
        "arguments": [{"arg": "string", "description": "要转换为大写的字符串"}],
        "examples": [{"expression": "'hello WOrld'.toUpperCase()", "returns": "'HELLO WORLD'"}],
        "tags": ["converts", "upper", "letters", "case"]
    }], [{
        "name": "trim",
        "type": "function",
        "groups": ["String"],
        "description": "Removes all leading and trailing whitespace (spaces, tabs, etc) from a string.",
        "arguments": [{"arg": "string", "description": "string to trim"}],
        "examples": [{"expression": "'   hello world  '.trim()", "returns": "'hello world'"}],
        "tags": ["removes", "leading", "whitespace", "spaces", "tabs", "trailing"]
    }, {
        "name": "trim",
        "type": "function",
        "groups": ["String"],
        "description": "从字符串中删除所有前导和尾随空格（空格、制表符等）。",
        "arguments": [{"arg": "string", "description": "要去首尾空格的字符串"}],
        "examples": [{"expression": "'   hello world  '.trim()", "returns": "'hello world'"}],
        "tags": ["removes", "leading", "whitespace", "spaces", "tabs", "trailing"]
    }]]
}, {
    "title": "日期",
    "children": [[{
        "name": "date",
        "type": "function",
        "groups": ["Date and Time"],
        "description": "Get the current time, or convert the time to a specified format.",
        "method": "new Date('date_string')",
        "arguments": [{
            "arg": "date",
            "optionals": "true",
            "description": "Returns the current date and time or a specified date and time."
        }],
        "examples": [{
            "expression": "new Date()",
            "returns": "2024-10-28 14:23:12"
        }, {"expression": "new Date('2012,5,12')", "returns": "2012-05-12"}],
        "tags": ["difference", "needs", "datetimes", "order", "extract", "information", "following", "interval", "dates", "functions", "year", "month", "week", "day", "hour", "minute", "second"]
    }, {
        "name": "date",
        "type": "function",
        "groups": ["Date and Time"],
        "description": "获取当前时间,或指定格式的时间转换。",
        "method": "new Date('date_string')",
        "arguments": [{
            "arg": "date",
            "optionals": "true",
            "description": "返回当前的日期时间 或 指定日期字符串的日期时间"
        }],
        "examples": [{
            "expression": "new Date()",
            "returns": "2024-10-28 14:23:12"
        }, {"expression": "new Date('2012,5,12')", "returns": "2012-05-12"}],
        "tags": ["difference", "needs", "datetimes", "order", "extract", "information", "following", "interval", "dates", "functions", "year", "month", "week", "day", "hour", "minute", "second"]
    }], [{
        "name": "day_of_week",
        "type": "function",
        "groups": ["Date and Time"],
        "description": "Returns the day of the week for a specified date or datetime. The returned value ranges from 0 to 6, where 0 corresponds to a Sunday and 6 to a Saturday.",
        "method": "day_of_week(date)",
        "arguments": [{"arg": "date", "description": "date or datetime value"}],
        "examples": [{"expression": "day_of_week(new Date('2015-09-21'))", "returns": "1"}],
        "tags": ["week", "day", "specified", "datetime", "corresponds", "ranges", "date", "saturday"]
    }, {
        "name": "day_of_week",
        "type": "function",
        "groups": ["日期和时间"],
        "description": "返回指定日期或日期时间的星期几。返回值范围为 0 到 6,其中 0 代表星期日,6 代表星期六。",
        "method": "day_of_week(date)",
        "arguments": [{"arg": "date", "description": "日期或日期时间值"}],
        "examples": [{"expression": "day_of_week(new Date('2015-09-21'))", "returns": "1"}],
        "tags": ["week", "day", "specified", "datetime", "corresponds", "ranges", "date", "saturday"]
    }], [{
        "name": "getDate",
        "type": "function",
        "groups": ["Date and Time"],
        "description": "Extracts the day from a date.",
        "method": "(new Date()).getDate()",
        "arguments": [{"arg": "date", "description": "a date or datetime value"}],
        "examples": [{"expression": "(new Date('2012-05-12')).getDate()", "returns": "12"}],
        "tags": ["date", "extracts", "interval", "days", "number", "day"]
    }, {
        "name": "getDate",
        "type": "function",
        "groups": ["Date and Time"],
        "description": "从日期中提取日期。",
        "method": "(new Date()).getDate()",
        "arguments": [{"arg": "date", "description": "日期或日期时间值"}],
        "examples": [{"expression": "(new Date('2012-05-12')).getDate()", "returns": "12"}],
        "tags": ["date", "extracts", "interval", "days", "number", "day"]
    }], [{
        "name": "getDay",
        "type": "function",
        "groups": ["Date and Time"],
        "description": "Extracts the day of week from a date.",
        "method": "(new Date()).getDay()",
        "arguments": [{"arg": "date", "description": "a date or datetime value"}],
        "examples": [{"expression": "(new Date()).getDay()", "returns": "1    \/\/Monday"}],
        "tags": ["week", "extracts", "interval", "days", "number", "day"]
    }, {
        "name": "getDay",
        "type": "function",
        "groups": ["Date and Time"],
        "description": "从日期中提取星期几。",
        "method": "(new Date()).getDay()",
        "arguments": [{"arg": "date", "description": "日期或日期时间值"}],
        "examples": [{"expression": "(new Date()).getDay()", "returns": "1   \/\/星期一"}],
        "tags": ["week", "extracts", "interval", "days", "number", "day"]
    }], [{
        "name": "getFullYear",
        "type": "function",
        "groups": ["Date and Time"],
        "description": "Extracts the year from a date.",
        "method": "(new Date()).getFullYear()",
        "arguments": [{"arg": "date", "description": "a date or datetime value"}],
        "examples": [{"expression": "(new Date('2012-05-12')).getFullYear()", "returns": "2012"}],
        "tags": ["year", "extracts", "interval", "days", "number", "day"]
    }, {
        "name": "getFullYear",
        "type": "function",
        "groups": ["Date and Time"],
        "description": "从日期中提取年份。",
        "method": "(new Date()).getFullYear()",
        "arguments": [{"arg": "date", "description": "日期或日期时间值"}],
        "examples": [{"expression": "(new Date('2012-05-12')).getFullYear()", "returns": "2012"}],
        "tags": ["year", "extracts", "interval", "days", "number", "day"]
    }], [{
        "name": "getHours",
        "type": "function",
        "groups": ["Date and Time"],
        "description": "Extracts the Hours from a date.",
        "method": "(new Date()).getHours()",
        "arguments": [{"arg": "date", "description": "a date or datetime value"}],
        "examples": [{"expression": "(new Date('2012-05-12 14:35:46')).getHours()", "returns": "14"}],
        "tags": ["Hours", "extracts", "interval", "days", "number", "day"]
    }, {
        "name": "getHours",
        "type": "function",
        "groups": ["Date and Time"],
        "description": "从日期中提取小时。",
        "method": "(new Date()).getHours()",
        "arguments": [{"arg": "date", "description": "日期或日期时间值"}],
        "examples": [{"expression": "(new Date('2012-05-12 14:35:46')).getHours()", "returns": "14"}],
        "tags": ["Hours", "extracts", "interval", "days", "number", "day"]
    }], [{
        "name": "getMinutes",
        "type": "function",
        "groups": ["Date and Time"],
        "description": "Extracts the minutes from a date.",
        "method": "(new Date()).getMinutes()",
        "arguments": [{"arg": "date", "description": "a date or datetime value"}],
        "examples": [{"expression": "(new Date('2012-05-12 14:35:46')).getMinutes()", "returns": "35"}],
        "tags": ["minutes", "extracts", "interval", "days", "number", "day"]
    }, {
        "name": "getMinutes",
        "type": "function",
        "groups": ["Date and Time"],
        "description": "从日期中提取分钟数。",
        "method": "(new Date()).getMinutes()",
        "arguments": [{"arg": "date", "description": "日期或日期时间值"}],
        "examples": [{"expression": "(new Date('2012-05-12 14:35:46')).getMinutes()", "returns": "35"}],
        "tags": ["minutes", "extracts", "interval", "days", "number", "day"]
    }], [{
        "name": "getMonth",
        "type": "function",
        "groups": ["Date and Time"],
        "description": "Extracts the month from a date.",
        "method": "(new Date()).getMonth()",
        "arguments": [{"arg": "date", "description": "a date or datetime value"}],
        "examples": [{"expression": "(new Date('2012-05-12')).getMonth()", "returns": "5"}],
        "tags": ["month", "extracts", "interval", "days", "number", "day"]
    }, {
        "name": "getMonth",
        "type": "function",
        "groups": ["Date and Time"],
        "description": "从日期中提取月份。",
        "method": "(new Date()).getMonth()",
        "arguments": [{"arg": "date", "description": "日期或日期时间值"}],
        "examples": [{"expression": "(new Date('2012-05-12')).getMonth()", "returns": "5"}],
        "tags": ["month", "extracts", "interval", "days", "number", "day"]
    }], [{
        "name": "getSecondes",
        "type": "function",
        "groups": ["Date and Time"],
        "description": "Extracts the Secondes from a date.",
        "method": "(new Date()).getSecondes()",
        "arguments": [{"arg": "date", "description": "a date or datetime value"}],
        "examples": [{"expression": "(new Date('2012-05-12 14:35:46')).getSecondes()", "returns": "35"}],
        "tags": ["secondes", "extracts", "interval", "days", "number", "day"]
    }, {
        "name": "getSecondes",
        "type": "function",
        "groups": ["Date and Time"],
        "description": "从日期中提取秒数。",
        "method": "(new Date()).getSecondes()",
        "arguments": [{"arg": "date", "description": "日期或日期时间值"}],
        "examples": [{"expression": "(new Date('2012-05-12 14:35:46')).getSecondes()", "returns": "35"}],
        "tags": ["minutes", "extracts", "interval", "days", "number", "day"]
    }], [{
        "name": "getWeek",
        "type": "function",
        "groups": ["Date and Time"],
        "description": "Returns the number of weeks in this year. 1-53。",
        "method": "(new Date()).getWeek()",
        "arguments": [{"arg": "date", "description": "the date"}],
        "examples": [{"expression": "(new Date()).getWeek()", "returns": "1   \/\/星期一"}],
        "tags": ["week", "extracts", "interval", "days", "number", "day"]
    }, {
        "name": "getWeek",
        "type": "function",
        "groups": ["Date and Time"],
        "description": "返回年份的周数 1-53。",
        "method": "(new Date()).getWeek()",
        "arguments": [{"arg": "date", "description": "日期或日期时间值"}],
        "examples": [{"expression": "(new Date()).getWeek()", "returns": "1   \/\/星期一"}],
        "tags": ["week", "extracts", "interval", "days", "number", "day"]
    }], [{
        "name": "now",
        "type": "function",
        "groups": ["Date and Time"],
        "description": "The method returns the number of milliseconds since January 1, 1970 00:00:00 UTC to the current time.",
        "method": "Date.now()",
        "examples": [{"expression": "Date.now()", "returns": "823420394123123"}],
        "tags": ["static", "evaluating", "current", "date", "time"]
    }, {
        "name": "now",
        "type": "function",
        "groups": ["Date and Time"],
        "description": "方法返回自1970年1月1日 00:00:00 UTC到当前时间的毫秒数。",
        "method": "Date.now()",
        "examples": [{"expression": "Date.now()", "returns": "823420394123123"}],
        "tags": ["static", "evaluating", "current", "date", "time"]
    }], [{
        "name": "parse",
        "type": "function",
        "groups": ["Date and Time"],
        "description": "Returns the timestamp of a date string.",
        "method": "Date.parse('date_string')",
        "arguments": [{"arg": "date_string", "description": "A string of datetime"}],
        "examples": [{"expression": "Date.parse('2017-01-01T00:00:00')", "returns": "1483225200000"}],
        "tags": ["passed", "datetime", "localtime", "msecs", "date", "coordinated", "converted", "universal", "milliseconds", "time"]
    }, {
        "name": "parse",
        "type": "function",
        "groups": ["Date and Time"],
        "description": "返回对应日期字符串的时间戳。.",
        "method": "Date.parse('date_string')",
        "arguments": [{"arg": "date_string", "description": "一个日期字符串"}],
        "examples": [{"expression": "Date.parse('2017-01-01T00:00:00')", "returns": "1483225200000"}],
        "tags": ["passed", "datetime", "localtime", "msecs", "date", "coordinated", "converted", "universal", "milliseconds", "time"]
    }]]
}, {
    "title": "类型转换",
    "children": [[{
        "name": "atob",
        "groups": ["Conversions"],
        "type": "function",
        "description": "Decodes a string in the Base64 encoding into a binary value.",
        "arguments": [{"arg": "string", "description": "the string to decode"}],
        "examples": [{"expression": "atob('QmlnZW1hcA==')", "returns": "'Bigemap'"}],
        "tags": ["decoding", "base64", "binary", "decodes"]
    }, {
        "name": "atob",
        "groups": ["Conversions"],
        "type": "function",
        "description": "将 Base64 编码中的字符串解码为二进制值。",
        "arguments": [{"arg": "string", "description": "要解码的字符串"}],
        "examples": [{"expression": "atob('QmlnZW1hcA==')", "returns": "'Bigemap'"}],
        "tags": ["decoding", "base64", "binary", "decodes"]
    }], [{
        "name": "btoa",
        "groups": ["Conversions"],
        "type": "function",
        "description": "Encodes a binary value into a string, using the Base64 encoding.",
        "arguments": [{"arg": "value", "description": "the binary value to encode"}],
        "examples": [{"expression": "btoa('Bigemap')", "returns": "'QmlnZW1hcA=='"}],
        "tags": ["encoding", "base64", "binary", "encodes"]
    }, {
        "name": "btoa",
        "groups": ["Conversions"],
        "type": "function",
        "description": "使用 Base64 编码将二进制值编码为字符串。",
        "arguments": [{"arg": "value", "description": "要编码的二进制值"}],
        "examples": [{"expression": "btoa('Bigemap')", "returns": "'QmlnZW1hcA=='"}],
        "tags": ["encoding", "base64", "binary", "encodes"]
    }], [{
        "name": "parseInt",
        "type": "function",
        "groups": ["Conversions"],
        "description": "Converts a string to integer number. If a value cannot be converted to integer the expression is invalid (e.g '123asd' is invalid).",
        "arguments": [{"arg": "string", "description": "string to convert to integer number"}],
        "examples": [{"expression": "parseInt('123')", "returns": "123"}, {
            "expression": "parseInt('12',2)",
            "returns": "1010"
        }],
        "tags": ["converts", "invalid", "converted", "integer"]
    }, {
        "name": "parseInt",
        "type": "function",
        "groups": ["Conversions"],
        "description": "将字符串转换为整数。如果值无法转换为整数,则表达式无效（例如 '123asd' 无效）。",
        "arguments": [{"arg": "string", "description": "要转换为整数的字符串"}],
        "examples": [{
            "expression": "parseInt('123')",
            "returns": "123"
        }, {"expression": "parseInt('12',2)  \/\/转成2进制,也可以16进制", "returns": "1010"}],
        "tags": ["converts", "invalid", "converted", "integer"]
    }]]
}]